
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("48Eol", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $ba2ff1d1fd865be7$export$6d1402fb58384e4f);
$parcel$export(module.exports, "PageLayoutInner", () => $ba2ff1d1fd865be7$export$f94607b1528a8807);
/* eslint-disable react/no-danger */ /* eslint-disable react/no-children-prop */ 
var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $lhCUr = parcelRequire("lhCUr");

var $ipPpS = parcelRequire("ipPpS");

var $6cnUO = parcelRequire("6cnUO");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $4kfV4 = parcelRequire("4kfV4");

var $eK5zz = parcelRequire("eK5zz");

var $4ntZx = parcelRequire("4ntZx");

var $1imNS = parcelRequire("1imNS");

var $82dFP = parcelRequire("82dFP");

var $58PBI = parcelRequire("58PBI");

var $dIouf = parcelRequire("dIouf");

var $kVysQ = parcelRequire("kVysQ");
var $6CEg5 = parcelRequire("6CEg5");

var $7xVCs = parcelRequire("7xVCs");

var $5XPyz = parcelRequire("5XPyz");

var $3PXtn = parcelRequire("3PXtn");

var $l4CMG = parcelRequire("l4CMG");

var $3hLsK = parcelRequire("3hLsK");

var $52id1 = parcelRequire("52id1");
var $6zNhq = parcelRequire("6zNhq");

var $azYNm = parcelRequire("azYNm");

var $1NBp8 = parcelRequire("1NBp8");

var $7zgzO = parcelRequire("7zgzO");

var $hZpML = parcelRequire("hZpML");

var $1C7kY = parcelRequire("1C7kY");

var $k06vE = parcelRequire("k06vE");

var $iCTcO = parcelRequire("iCTcO");

var $9wGTI = parcelRequire("9wGTI");

var $5JnXv = parcelRequire("5JnXv");

var $liCZ6 = parcelRequire("liCZ6");

var $gsf3i = parcelRequire("gsf3i");

var $bwL2u = parcelRequire("bwL2u");

var $cJWhP = parcelRequire("cJWhP");

var $6o8J3 = parcelRequire("6o8J3");

var $eJTjU = parcelRequire("eJTjU");

var $lpfM9 = parcelRequire("lpfM9");

var $kmLIp = parcelRequire("kmLIp");

var $lPNJr = parcelRequire("lPNJr");

var $fKEgu = parcelRequire("fKEgu");

var $JEZ6P = parcelRequire("JEZ6P");

var $1qDZ3 = parcelRequire("1qDZ3");
const $ba2ff1d1fd865be7$var$TOP_NAV_HEIGHT = 48;
const $ba2ff1d1fd865be7$var$isRoute = (pathname, route)=>Boolean(route.match(pathname || ''));
const $ba2ff1d1fd865be7$var$routesToShowPageLayoutBreadcrumbNav = [
    (0, $1NBp8.CUSTOM_CONTENTS_ON_PAGE_LIST),
    (0, $1NBp8.SPACE_PAGES),
    (0, $1NBp8.SPACE_CALENDARS),
    (0, $1NBp8.DATABASE_CUSTOM_OVERVIEW),
    (0, $1NBp8.SPACE_QUESTIONS)
];
const $ba2ff1d1fd865be7$export$6d1402fb58384e4f = /*#__PURE__*/ (0, $gwFzn.memo)(({ children: children, view: view, standalone: standalone, isSpaceSettingsScreen: isSpaceSettingsScreen, editorPreloader: editorPreloader })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE,
        attributes: {
            errorBoundaryId: 'PageLayout-outer'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ba2ff1d1fd865be7$export$f94607b1528a8807, {
        children: children,
        view: view,
        standalone: standalone,
        isSpaceSettingsScreen: isSpaceSettingsScreen,
        editorPreloader: editorPreloader
    }));
});
const $ba2ff1d1fd865be7$export$f94607b1528a8807 = ({ children: children, view: view, standalone: standalone, isSpaceSettingsScreen: isSpaceSettingsScreen = false, editorPreloader: editorPreloader = $ba2ff1d1fd865be7$var$noopEditorPreloader })=>{
    const { pageTreeUpdater: pageTreeUpdater } = (0, $eJTjU.useScrollTree)({
        view: view
    });
    const { isLoading: isLoading, isError: isError, isPanelOpen: isPanelOpen, isDismissed: isDismissed, openComponentId: openComponentId } = (0, $6zNhq.useQuickstartState)();
    const { isQuickstartEligible: isQuickstartEligible } = (0, $52id1.useQuickstartEligible)();
    const jswSpotlightOpen = openComponentId === (0, $3hLsK.SHOW_SWITCHER_SPOTLIGHT_ONLY) || openComponentId === (0, $3hLsK.JSW_XFLOW_SWITCHER_TOUR_TASK);
    // By default, the blanket should not be tinted, only tinted if onboarding jsw switcher spotlights are active
    const spotlightTriggeredByJswQS = isPanelOpen && !isDismissed && jswSpotlightOpen;
    const isQuickStartOpen = isPanelOpen && !isDismissed && !isLoading && !isError && isQuickstartEligible();
    const intl = (0, $dBxQj.default)();
    const { location: location } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    // show breadcrumb nav for routes listed in routesToShowPageLayoutBreadcrumbNav
    const showBreadcrumbNavHeader = $ba2ff1d1fd865be7$var$routesToShowPageLayoutBreadcrumbNav.some((route)=>$ba2ff1d1fd865be7$var$isRoute(location?.pathname, route));
    const SideNavSkiplinkText = intl.formatMessage((0, $kmLIp.i18n).SideNav);
    const nonceValue = window.__SSR_NONCE_VALUE__;
    const standaloneGlobalStylesCompiled = (bannerHeight)=>standalone ? /*
   * We're injecting global styles to handle styling targets that are not part of the React app, but are children of the HTML body
   * Previously, this used to be a `<Global styles={[…]} />` from Emotion
   * But in the Compiled migration, there is no alternative and feels like the best path forward for now.
   */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("style", {
            type: "text/css",
            dangerouslySetInnerHTML: {
                __html: (0, $lPNJr.fixSSRContentForNewLayoutWithRightSidebarStyles)
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("style", {
            ...nonceValue !== undefined ? {
                nonce: nonceValue
            } : {},
            type: "text/css",
            dangerouslySetInnerHTML: {
                __html: (0, $lPNJr.globalStylesCompiled)
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("style", {
            type: "text/css"
        }, `[${(0, $lPNJr.SSR_LAYOUT_DATA_ATTR)}], [${(0, $lPNJr.SSR_IFRAME_ATTR)}] {
					top: ${bannerHeight + $ba2ff1d1fd865be7$var$TOP_NAV_HEIGHT + 2}px !important;
				}`)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("style", {
            ...nonceValue !== undefined ? {
                nonce: nonceValue
            } : {},
            type: "text/css",
            dangerouslySetInnerHTML: {
                __html: (0, $lPNJr.globalStylesCompiled)
            }
        });
    const standaloneGlobalStyles = (bannerHeight)=>standalone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lhCUr.Global), {
            "data-testid": "global-styles-SSR",
            styles: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.StyleFixSSRContentForNewLayoutWithRightSidebar)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                bannerHeight + $ba2ff1d1fd865be7$var$TOP_NAV_HEIGHT),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.styleCodeBlockFix),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.fontFamilyCLSFix),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.styleNoPrintNav),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.moreActionDropdownCLSFix),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.accountMenuHeadingFix)
            ]
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lhCUr.Global), {
            "data-testid": "global-styles",
            styles: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.styleCodeBlockFix),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.fontFamilyCLSFix),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.styleNoPrintNav),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.moreActionDropdownCLSFix),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.accountMenuHeadingFix)
            ]
        });
    const [activeNav4Spotlight, setActiveNav4Spotlight] = (0, $gwFzn.useState)(null);
    const [isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive] = (0, $gwFzn.useState)(false);
    const stopNav4Spotlight = (0, $k06vE.useStopNav4Spotlight)(setActiveNav4Spotlight);
    const [{ isSpaceGettingStartedTourInProgress: isSpaceGettingStartedTourInProgress }] = (0, $l4CMG.useSpaceGettingStartedTour)();
    const { initialCollapsedState: initialCollapsedState } = (0, $fKEgu.useSideNavInitialState)();
    const [{ activeSpotlightIndex: moreActionsActiveSpotlightIndex }] = (0, $5JnXv.useMoreActionsObjectSidebarTourState)();
    const isModernizeChangeboardingActive = (0, $liCZ6.useModernizeChangeboardingActive)();
    const isRedactionsTourActive = (0, $gsf3i.useRedactionsTourIsActive)();
    const handleBlanketClicked = ()=>{
        if (activeNav4Spotlight !== null) stopNav4Spotlight();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE,
        attributes: {
            errorBoundaryId: 'PageLayoutInner'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cJWhP.NavigationExperienceWrapper), {
        view: view,
        navVersion: "4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6CEg5.PerformanceStart), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigation),
        subjectId: "NavigationLoading"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $58PBI.EditContentButtonPreloaderContext).Provider, {
        value: editorPreloader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $3PXtn.BannerStateContainer)
        ]
    }, (bannerState)=>{
        const bannerHeight = bannerState.getTotalHeight(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6cnUO.default), {
            blanketIsTinted: isSpaceGettingStartedTourInProgress || spotlightTriggeredByJswQS || activeNav4Spotlight !== null || moreActionsActiveSpotlightIndex !== null || isRedactionsTourActive || isModernizeChangeboardingActive || isNav4CollapseReminderSpotlightActive,
            onBlanketClicked: handleBlanketClicked
        }, (0, $9wGTI.fg)('confluence_frontend_page_layout_compiled') ? standaloneGlobalStylesCompiled(bannerHeight) : standaloneGlobalStyles(bannerHeight), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qDZ3.PageLayoutContextProviderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $82dFP.Root), {
            UNSAFE_dangerouslyHoistSlotSizes: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4ntZx.Banner), {
            height: bannerHeight,
            id: "AkBanner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5XPyz.BannerContainer), null)), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_TOP_NAV}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $JEZ6P.TopNav), {
            defaultCollapsed: initialCollapsedState === 'collapsed'
        }), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_TOP_NAV}.end`), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SIDE_NAV}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6o8J3.SideNavigation), {
            view: view,
            skiplinkText: SideNavSkiplinkText,
            isSpaceSettingsScreen: isSpaceSettingsScreen,
            activeNav4Spotlight: activeNav4Spotlight,
            setActiveNav4Spotlight: setActiveNav4Spotlight,
            isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive,
            setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
        }), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SIDE_NAV}.end`), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_MAIN}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1imNS.Main), {
            testId: "grid-main-container",
            id: "AkMainContent",
            isFixed: true
        }, (0, $9wGTI.fg)('confluence_page_tree_with_actions') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ba2ff1d1fd865be7$var$ContentTreeMultiSelectOverlay, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lPNJr.LayoutMainWrapper), {
            id: "layout-main-wrapper",
            showBreadcrumbNavHeader: showBreadcrumbNavHeader
        }, showBreadcrumbNavHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $azYNm.FixedBreadcrumbsNavForPageLayoutLoader), null), children && !standalone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
            attribution: (0, $dIouf.Attribution).DISCO
        }, showBreadcrumbNavHeader ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: $ba2ff1d1fd865be7$var$breadcrumbsOffsetStyles
        }, children) : children) : null, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_MAIN}.end`))), isQuickStartOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eK5zz.Panel), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lPNJr.ContentRightSidePanel), {
            id: "content-right-side-panel"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lpfM9.PanelLoader), {
            toggleInProductHelp: ()=>{}
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
            to: [
                (0, $7xVCs.PageTreeStateUpdater)
            ]
        }, (pageTreeStateUpdatesContainer)=>{
            pageTreeUpdater.current = pageTreeStateUpdatesContainer;
            return null;
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iCTcO.PreviewPanelContainer), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1C7kY.GlobalComponentsLoader), null)));
    }))));
};
const $ba2ff1d1fd865be7$var$ContentTreeMultiSelectOverlay = ()=>{
    const [{ isMultiSelectActive: isMultiSelectActive }] = (0, $bwL2u.useContentTreeSelection)();
    return isMultiSelectActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4kfV4.default), {
        isTinted: true,
        testId: "content-tree-multi-select-blanket"
    }) : null;
};
const $ba2ff1d1fd865be7$var$breadcrumbsOffsetStyles = (0, $ecnYn.xcss)({
    // @ts-ignore This specific value is necessary to ensure the breadcrumbs are offset correctly
    marginTop: '60px'
});
const $ba2ff1d1fd865be7$var$noopEditorPreloader = ()=>null;

});
parcelRegister("4ntZx", function(module, exports) {

$parcel$export(module.exports, "Banner", () => $f0df34b67538a54c$export$3b4e64e77073e307);
/* banner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dh538 = parcelRequire("dh538");

var $dEIJ1 = parcelRequire("dEIJ1");

var $K0HEo = parcelRequire("K0HEo");

var $8jREP = parcelRequire("8jREP");

var $dGAIk = parcelRequire("dGAIk");

var $bgZhH = parcelRequire("bgZhH");
const $f0df34b67538a54c$var$styles = {
    root: "_nd5ldkfm _1reo15vq _18m915vq _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat"
}; /**
    * The banner layout area. It will always be displayed at the top of the screen.
    *
    * Should be used to render a `Banner` component from `@atlaskit/banner`.
    */ 
function $f0df34b67538a54c$export$3b4e64e77073e307({ children: children, xcss: xcss, height: // 48px has been chosen to align with the height of the Banner component from `@atlaskit/banner`.
height = (0, $dh538.fg)('platform_dst_nav4_banner_default_height') ? 48 : 64, skipLinkLabel: skipLinkLabel = 'Banner', testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $gwFzn.useContext)((0, $8jREP.DangerouslyHoistSlotSizes));
    const id = (0, $bgZhH.useLayoutId)({
        providedId: providedId
    }); /**
       * Don't show the skip link if the slot has 0 height.
       */ 
    (0, $dEIJ1.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: height === 0
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $35pXk.default)([
            $f0df34b67538a54c$var$styles.root,
            xcss
        ]),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dGAIk.HoistCssVarToLocalGrid), {
                variableName: (0, $K0HEo.bannerMountedVar),
                value: height
            }),
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dGAIk.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $K0HEo.UNSAFE_bannerVar),
                value: height
            }) // ------ END UNSAFE STYLES ------
            ,
            children
        ]
    });
}

});

parcelRegister("6o8J3", function(module, exports) {

$parcel$export(module.exports, "SideNavigation", () => $b56ca6efd7e1c0fa$export$cc4f63927c41742f);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $hnvzE = parcelRequire("hnvzE");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $bssir = parcelRequire("bssir");

var $1fdQV = parcelRequire("1fdQV");
var $lxWrw = parcelRequire("lxWrw");
var $1cuAd = parcelRequire("1cuAd");
var $622t3 = parcelRequire("622t3");

var $3Fgla = parcelRequire("3Fgla");

var $dIouf = parcelRequire("dIouf");

var $7aRa9 = parcelRequire("7aRa9");

var $jFFx4 = parcelRequire("jFFx4");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $de2j9 = parcelRequire("de2j9");

var $7uIhU = parcelRequire("7uIhU");

var $bbp3G = parcelRequire("bbp3G");

var $ljm2R = parcelRequire("ljm2R");

var $7zgzO = parcelRequire("7zgzO");

var $cEgMD = parcelRequire("cEgMD");

var $ep3mz = parcelRequire("ep3mz");

var $hQnHK = parcelRequire("hQnHK");

var $iQuWQ = parcelRequire("iQuWQ");

var $9wGTI = parcelRequire("9wGTI");

var $6mKj3 = parcelRequire("6mKj3");

var $efvKr = parcelRequire("efvKr");

var $i8GdI = parcelRequire("i8GdI");

var $jFmKR = parcelRequire("jFmKR");

var $j2aYM = parcelRequire("j2aYM");

var $7Sm4c = parcelRequire("7Sm4c");

var $bQm3c = parcelRequire("bQm3c");

var $1Sim2 = parcelRequire("1Sim2");

var $dzFiN = parcelRequire("dzFiN");

var $dFqEJ = parcelRequire("dFqEJ");

var $8zMP3 = parcelRequire("8zMP3");

var $bgTcf = parcelRequire("bgTcf");

var $7S7nY = parcelRequire("7S7nY");

var $hAauA = parcelRequire("hAauA");

var $8w7kh = parcelRequire("8w7kh");

var $73ZeC = parcelRequire("73ZeC");

var $ib3XP = parcelRequire("ib3XP");
var $92JEG = parcelRequire("92JEG");

var $5UY0r = parcelRequire("5UY0r");

var $fKEgu = parcelRequire("fKEgu");

var $eJTjU = parcelRequire("eJTjU");

var $2esS1 = parcelRequire("2esS1");

var $c5xYC = parcelRequire("c5xYC");

var $cLmDJ = parcelRequire("cLmDJ");
const $b56ca6efd7e1c0fa$var$i18n = (0, $2nPZH.defineMessages)({
    dragHandle: {
        id: "page-layout.side-navigation.drag-handle",
        defaultMessage: "Side Navigation Drag Handle"
    },
    globalInviteButtonLabel: {
        id: "page-layout.side-navigation.global-invite-button-label",
        defaultMessage: "Invite people"
    }
});
const $b56ca6efd7e1c0fa$var$resize = ()=>{
    window.dispatchEvent(new Event('resize'));
};
const $b56ca6efd7e1c0fa$var$ExpandKeyboardShortcut = ({ onToggleFromShortcut: onToggleFromShortcut })=>{
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const toggleSideNav = (0, $622t3.useToggleSideNav)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const toggle = (0, $gwFzn.useCallback)(()=>{
        if (!(0, $bbp3G.isDialogShown)()) {
            onToggleFromShortcut();
            toggleSideNav();
        }
    }, [
        onToggleFromShortcut,
        toggleSideNav
    ]);
    return isLiveEditMode || isOnEditRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutListener), {
        accelerator: (0, $ljm2R.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
        listener: toggle
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        accelerator: [
            (0, $ljm2R.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
            (0, $ljm2R.SIDE_NAVIGATION_SHORTCUT)
        ],
        listener: toggle
    });
};
const $b56ca6efd7e1c0fa$var$useIsModeGlobal = ()=>{
    const { match: match } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    return match?.query?.mode === 'global' || (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
};
const $b56ca6efd7e1c0fa$var$isSpaceNavigationView = (view)=>{
    return view === (0, $2esS1.CONTAINER_HOME_ID) || view === (0, $2esS1.CONTAINER_BLOG_ID);
};
//todo: are all these views still relevant? I'm not certain they are
const $b56ca6efd7e1c0fa$var$getProductSideNavigation = (view, isSpaceSettingsScreen, isModeGlobal, isOnAnySettingsScreen, activeNav4Spotlight, setActiveNav4Spotlight, unhandledError, isLicensed)=>{
    // hide product nav if mode=global unless we're on a settings page
    if (isModeGlobal && !isOnAnySettingsScreen) return null;
    // Update the utility function if logic changes for determining SpaceNavigation.
    // This ensures consistent behavior across the app, as the check is used in the footer as well.
    if ($b56ca6efd7e1c0fa$var$isSpaceNavigationView(view)) {
        if (view === (0, $2esS1.CONTAINER_HOME_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7uIhU.SpaceNavigation), {
            isSpaceSettingsScreen: isSpaceSettingsScreen,
            activeNav4Spotlight: activeNav4Spotlight,
            setActiveNav4Spotlight: setActiveNav4Spotlight,
            ...unhandledError && {
                unhandledError: unhandledError
            }
        });
        if (view === (0, $2esS1.CONTAINER_BLOG_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7uIhU.SpaceNavigation), {
            isBlogNavigation: true,
            isSpaceSettingsScreen: false,
            activeNav4Spotlight: activeNav4Spotlight,
            setActiveNav4Spotlight: setActiveNav4Spotlight
        });
    }
    switch(view){
        case 0, $2esS1.CONTAINER_HOME_LOADING_ID:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7uIhU.SpaceNavigationLoadingSkeleton), null);
        case 0, $2esS1.CONTAINER_ADMIN_HOME_ID:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7uIhU.SpaceAdminNavigation), null);
        case 0, $2esS1.COMPANY_HUB_SETTINGS_ID:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7uIhU.HubSettingsNavigation), null);
        case 0, $2esS1.ADMIN_HOME_ID:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7uIhU.AdminNavigationLoader), null);
    }
    return isLicensed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7uIhU.StarredSpacesList), null) : null;
};
const $b56ca6efd7e1c0fa$export$cc4f63927c41742f = ({ view: view, isSpaceSettingsScreen: isSpaceSettingsScreen, activeNav4Spotlight: activeNav4Spotlight, setActiveNav4Spotlight: setActiveNav4Spotlight, isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive })=>{
    const intl = (0, $dBxQj.default)();
    const isModeGlobal = $b56ca6efd7e1c0fa$var$useIsModeGlobal(); //instead of disabling the whole left nav, now mode=Global will disable only the space Navigation
    const { initialCollapsedState: initialCollapsedState, initialWidth: initialWidth, shouldForceExpand: shouldForceExpand } = (0, $fKEgu.useSideNavInitialState)();
    const { scrollTree: scrollTree } = (0, $eJTjU.useScrollTree)({
        view: view
    });
    const { saveCurrentRoute: saveCurrentRoute } = (0, $jFFx4.useSettingsBackButtonUtils)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isPageWithinSpaceSettings = view === (0, $2esS1.CONTAINER_ADMIN_HOME_ID);
    const isPageWithinSiteSettings = view === (0, $2esS1.ADMIN_HOME_ID);
    const isHubSettingsScreen = view === (0, $2esS1.COMPANY_HUB_SETTINGS_ID);
    const isOnAnySettingsScreen = isPageWithinSpaceSettings || isPageWithinSiteSettings || isHubSettingsScreen;
    const { nav4GlobalChangeboardingActive: nav4GlobalChangeboardingActive, nav4SpaceSettingsChangeboardingActive: nav4SpaceSettingsChangeboardingActive } = (0, $bgTcf.useModernizeChangeboardingState)();
    const expandSideNav = (0, $1cuAd.useExpandSideNav)();
    const { isUserViewingSpaceAsAnon: isUserViewingSpaceAsAnon, loading: anonymousAccessQueryLoading, error: anonymousAccessQueryError } = (0, $jFmKR.useIsUserViewingSpaceAsAnon)({
        spaceKey: spaceKey || ''
    });
    const { setIsCollapsed: setIsCollapsed } = (0, $cLmDJ.useSideNavigationCollapsedActions)();
    const { isEligibleForLand: isEligibleForLand, isEligibleForXflow: isEligibleForXflow } = (0, $dzFiN.useIsEligibleForEnhanceOrientationTour)();
    const isSpaceNavigationRoute = $b56ca6efd7e1c0fa$var$isSpaceNavigationView(view);
    const showEnhanceTourExperiment = isSpaceNavigationRoute && !isUserViewingSpaceAsAnon && isEligibleForLand && (0, $6mKj3.expValEquals)('cc-onboarding-enhance-orientation-tour-land', 'cohort', 'experiment') || isSpaceNavigationRoute && !isUserViewingSpaceAsAnon && isEligibleForXflow && (0, $6mKj3.expValEquals)('cc-onboarding-enhance-orientation-tour-xflow', 'cohort', 'experiment');
    const productSideNavigation = $b56ca6efd7e1c0fa$var$getProductSideNavigation(view, isSpaceSettingsScreen, isModeGlobal, isOnAnySettingsScreen, activeNav4Spotlight, setActiveNav4Spotlight, anonymousAccessQueryError, isLicensed);
    const [triggeredByShortcut, setTriggeredByShortcut] = (0, $gwFzn.useState)(false);
    const fireSidebarToggleAnalytics = (0, $gwFzn.useCallback)((action, triggeredBy)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: action,
                actionSubject: 'spaceNavigation',
                source: 'containerNavigation',
                attributes: {
                    isOnEditRoute: isOnEditRoute,
                    navigationLayer: 'global',
                    navigationContainer: 'top',
                    navVersion: '4',
                    triggeredBy: triggeredBy
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isOnEditRoute
    ]);
    const fireSidebarResizeEndAnalytics = (0, $gwFzn.useCallback)(({ initialWidth: initialWidth, finalWidth: finalWidth })=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'resized',
                actionSubject: 'spaceNavigation',
                source: 'containerNavigation',
                attributes: {
                    navigationLayer: 'global',
                    navigationContainer: 'top',
                    navVersion: '4',
                    initialWidth: initialWidth,
                    finalWidth: finalWidth
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onCollapse = (0, $gwFzn.useCallback)(()=>{
        setIsCollapsed(true);
        (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED, 'collapsed');
        $b56ca6efd7e1c0fa$var$resize();
        fireSidebarToggleAnalytics('collapsed', triggeredByShortcut ? 'keyboardShortcut' : 'click');
        setTriggeredByShortcut(false);
    }, [
        fireSidebarToggleAnalytics,
        triggeredByShortcut,
        setIsCollapsed
    ]);
    const onExpand = (0, $gwFzn.useCallback)(()=>{
        setIsCollapsed(false);
        (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED, 'expanded');
        scrollTree();
        $b56ca6efd7e1c0fa$var$resize();
        fireSidebarToggleAnalytics('expanded', triggeredByShortcut ? 'keyboardShortcut' : 'click');
        setTriggeredByShortcut(false);
    }, [
        scrollTree,
        fireSidebarToggleAnalytics,
        triggeredByShortcut,
        setIsCollapsed
    ]);
    const handleToggleFromShortcut = (0, $gwFzn.useCallback)(()=>{
        setTriggeredByShortcut(true);
    }, []);
    // If current route is not a settings page, save the current route to session storage.
    // The saved route is read by the back button whenever the user lands in Site or Space settings in the same session.
    if (!isPageWithinSpaceSettings && !isPageWithinSiteSettings && !isHubSettingsScreen) saveCurrentRoute();
    const { isNav4CollapseReminderSpotlightDismissed: isNav4CollapseReminderSpotlightDismissed } = (0, $92JEG.useHasDismissedNav4CollapseReminderSpotlight)();
    const { isNav4SpaceTourDismissed: isNav4SpaceTourDismissed, error: onboardingError } = (0, $hAauA.useGetModernizeChangeboardingOnboardingState)();
    const { hasDismissedNav4ChangeboardingViaEP: hasDismissedNav4ChangeboardingViaEP, error: tapError } = (0, $7S7nY.useModernizeChangeboardingTapTraits)();
    const error = onboardingError || tapError;
    const isNav4ChangeboardingDismissed = (0, $9wGTI.fg)('cc_modernize_ga_changeboarding') ? isNav4SpaceTourDismissed : hasDismissedNav4ChangeboardingViaEP;
    (0, $gwFzn.useEffect)(()=>{
        // Expand side nav when rendering certain nav4 spotlights
        if ((nav4GlobalChangeboardingActive || nav4SpaceSettingsChangeboardingActive) && (0, $9wGTI.fg)('cc_modernize_ga_changeboarding')) expandSideNav();
    }, [
        nav4GlobalChangeboardingActive,
        nav4SpaceSettingsChangeboardingActive,
        expandSideNav
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1fdQV.SideNav), {
        defaultWidth: initialWidth,
        defaultCollapsed: initialCollapsedState === 'collapsed',
        onExpand: onExpand,
        onCollapse: onCollapse,
        id: "side-navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "side-navigation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hnvzE.default), {
        name: "side-nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5UY0r.SideNavigationContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).DISCO,
        attributes: {
            errorBoundaryId: 'sideNavigation-globalNavigation'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7uIhU.GlobalNavigation), {
        withVisibleAppShortcuts: view === (0, $2esS1.PRODUCT_HOME_ID),
        productSideNavigation: productSideNavigation,
        isOnAnySettingsScreen: isOnAnySettingsScreen
    })), isNav4CollapseReminderSpotlightActive && setIsNav4CollapseReminderSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ib3XP.Nav4CollapseReminderSpotlightLoader), {
        setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
    }), !shouldForceExpand && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b56ca6efd7e1c0fa$var$ExpandKeyboardShortcut, {
        onToggleFromShortcut: handleToggleFromShortcut
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bssir.PanelSplitter), {
        onResizeEnd: ({ initialWidth: initialWidth, finalWidth: finalWidth })=>{
            $b56ca6efd7e1c0fa$var$handleResizeEnd({
                finalWidth: finalWidth,
                eligibleForCollapseReminderSpotlight: !isNav4CollapseReminderSpotlightActive && isNav4ChangeboardingDismissed && !isNav4CollapseReminderSpotlightDismissed && (0, $9wGTI.fg)('confluence_nav4_collapse_reminder_spotlight'),
                setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
            });
            fireSidebarResizeEndAnalytics({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
        },
        onResizeStart: $b56ca6efd7e1c0fa$var$onResizeStart,
        label: intl.formatMessage($b56ca6efd7e1c0fa$var$i18n.dragHandle)
    })), isPageWithinSiteSettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $73ZeC.NavigationBannerLoadable), null), isUserViewingSpaceAsAnon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i8GdI.AnonymousAccessSideNavMessage), null) : !anonymousAccessQueryLoading && !anonymousAccessQueryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b56ca6efd7e1c0fa$var$SideNavFooterWrapped, {
        showEnhanceTourExperiment: showEnhanceTourExperiment
    })), !(0, $9wGTI.fg)('cc_modernize_ga_changeboarding') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iQuWQ.CoordinatedNav4OnboardingModal), null)), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }));
};
const $b56ca6efd7e1c0fa$var$SideNavFooterWrapped = ({ showEnhanceTourExperiment: showEnhanceTourExperiment })=>//  Enhance Tour Experiment has staggered rollout with Next Best Action dial down
    (0, $9wGTI.fg)('post-office-connie-side-nav-killswitch') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, showEnhanceTourExperiment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dFqEJ.EnhanceOrientationTourNudgeLoader), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1Sim2.PostOfficeConfluenceSideNavPlacement), {
        nav4: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8w7kh.RtPaidFeatureEducationComponentLoadable), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lxWrw.SideNavFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.TransparentErrorBoundary), {
        attribution: (0, $dIouf.Attribution).NAVX
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b56ca6efd7e1c0fa$var$SideNavFooterContent, null)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lxWrw.SideNavFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.TransparentErrorBoundary), {
        attribution: (0, $dIouf.Attribution).NAVX
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b56ca6efd7e1c0fa$var$SideNavFooterContent, null)));
const $b56ca6efd7e1c0fa$var$globalInviteButtonStyles = (0, $ecnYn.xcss)({
    flexGrow: 1
});
const $b56ca6efd7e1c0fa$var$Nav4SideNavFooterContent = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $b56ca6efd7e1c0fa$var$globalInviteButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3Fgla.GlobalInviteWithLazyLoadedRelayProvider), {
        product: "confluence",
        showFlag: flags.showFlag
    }, intl.formatMessage($b56ca6efd7e1c0fa$var$i18n.globalInviteButtonLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c5xYC.Nav4GiveFeedbackButton), {
        iconOnly: true
    }));
});
const $b56ca6efd7e1c0fa$var$SideNavFooterContent = ()=>{
    const { error: error, loading: loading, isEligible: isEligible } = (0, $j2aYM.usePersistentInviteButtonEligible)();
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c5xYC.Nav4GiveFeedbackButton), null);
    if (error) {
        if ((0, $dIouf.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
            error: error
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c5xYC.Nav4GiveFeedbackButton), null));
    }
    return isEligible && (0, $9wGTI.fg)('confluence_nav4_global-invite') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b56ca6efd7e1c0fa$var$Nav4SideNavFooterContent, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c5xYC.Nav4GiveFeedbackButton), null);
};
// CCT-951 TEMPORARY WORKAROUND to allow resizing of side-nav when viewing a Whiteboard (rendered in an iFrame)
// Can be removed when DSP-5931 is fixed and @atlaskit/page-layout is bumped
const $b56ca6efd7e1c0fa$var$onResizeStart = ()=>{
    document.querySelector(`iframe[title="${(0, $hQnHK.WHITEBOARD_IFRAME_TITLE)}"]`)?.style.setProperty('pointer-events', 'none');
};
const $b56ca6efd7e1c0fa$var$SIDE_NAVIGATION_MIN_WIDTH = 240;
const $b56ca6efd7e1c0fa$var$handleResizeEnd = ({ finalWidth: finalWidth, eligibleForCollapseReminderSpotlight: eligibleForCollapseReminderSpotlight, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive })=>{
    // CCT-951 TEMPORARY WORKAROUND to allow resizing of side-nav when viewing a Whiteboard (rendered in an iFrame)
    // Can be removed when DSP-5931 is fixed and @atlaskit/page-layout is bumped
    document.querySelector(`iframe[title="${(0, $hQnHK.WHITEBOARD_IFRAME_TITLE)}"]`)?.style.removeProperty('pointer-events');
    (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_WIDTH, finalWidth);
    if (finalWidth <= $b56ca6efd7e1c0fa$var$SIDE_NAVIGATION_MIN_WIDTH && eligibleForCollapseReminderSpotlight) setIsNav4CollapseReminderSpotlightActive?.(true);
};

});
parcelRegister("1fdQV", function(module, exports) {

$parcel$export(module.exports, "SideNav", () => $897ab7f8a2e9a596$export$1a35787d6353cf6a);
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $d8F95 = parcelRequire("d8F95");

var $4FhhO = parcelRequire("4FhhO");

var $3654r = parcelRequire("3654r");

var $fQcKS = parcelRequire("fQcKS");
var $6UUmP = parcelRequire("6UUmP");

var $dh538 = parcelRequire("dh538");

var $4T4vf = parcelRequire("4T4vf");

var $bWLcG = parcelRequire("bWLcG");

var $dEIJ1 = parcelRequire("dEIJ1");

var $7plVH = parcelRequire("7plVH");

var $K0HEo = parcelRequire("K0HEo");

var $8jREP = parcelRequire("8jREP");

var $dGAIk = parcelRequire("dGAIk");

var $bgZhH = parcelRequire("bgZhH");

var $c9vFp = parcelRequire("c9vFp");

var $38bxn = parcelRequire("38bxn");

var $dh62b = parcelRequire("dh62b");

var $5IbFD = parcelRequire("5IbFD");

var $5fMbj = parcelRequire("5fMbj");

var $1cuAd = parcelRequire("1cuAd");

var $7R2w7 = parcelRequire("7R2w7");

var $8qoQE = parcelRequire("8qoQE");

var $622t3 = parcelRequire("622t3");

var $cvtof = parcelRequire("cvtof");
const $897ab7f8a2e9a596$var$panelSplitterResizingVar = '--n_snvRsz';
const $897ab7f8a2e9a596$var$widthResizeBounds = {
    min: '240px',
    max: '50vw'
};
function $897ab7f8a2e9a596$var$getResizeBounds() {
    return $897ab7f8a2e9a596$var$widthResizeBounds;
}
const $897ab7f8a2e9a596$var$openLayerObserverSideNavNamespace = 'side-nav';
const $897ab7f8a2e9a596$var$styles = {
    root: "_nd5l1b6c _bfhk1bhr _16qs1cd0 _vchhusvi _4t3ieqxy _152timx3 _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _qilnk0mc _4ap3vuon _scbpglyw",
    oldBorder: "_t51zzgxb",
    newBorder: "_191wglyw _t51zglyw _p5clzgxb",
    newBorderFlyoutOpen: "_p5clglyw",
    flyoutOpen: "_qiln1gzg _4ap31bhr _scbp1cd0 _139f8iot _1tpvfnf5 _sylc1a5r _oyeijq3t",
    flyoutAnimateClosed: "_1e0cglyw _qiln1gzg _139f8iot _1tpvfnf5 _sylc1a5r _1uwsjq3t",
    flexContainer: "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
    hiddenMobileAndDesktop: "_1e0cglyw",
    hiddenMobileOnly: "_1e0cglyw _dm2518uv",
    hiddenDesktopOnly: "_dm25glyw"
};
function $897ab7f8a2e9a596$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Sidebar', skipLinkLabel: skipLinkLabel = label, onExpand: onExpand, onCollapse: onCollapse, id: providedId }) {
    const id = (0, $bgZhH.useLayoutId)({
        providedId: providedId
    });
    const expandSideNav = (0, $1cuAd.useExpandSideNav)(); /**
                                             * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
                                             *
                                             * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
                                             */ 
    const synchronouslyExpandSideNav = (0, $gwFzn.useCallback)(()=>{
        (0, $4FhhO.flushSync)(()=>{
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandSideNav` makes.
       */ expandSideNav();
        });
    }, [
        expandSideNav
    ]);
    (0, $dEIJ1.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        onBeforeNavigate: synchronouslyExpandSideNav
    });
    const sideNavState = (0, $gwFzn.useContext)((0, $cvtof.SideNavVisibilityState));
    const setSideNavState = (0, $gwFzn.useContext)((0, $cvtof.SetSideNavVisibilityState));
    const { isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile } = (0, $7R2w7.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    }); // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    const [initialDefaultCollapsed] = (0, $gwFzn.useState)(defaultCollapsed);
    const [width, setWidth] = (0, $gwFzn.useState)(defaultWidth);
    const clampedWidth = `clamp(${$897ab7f8a2e9a596$var$widthResizeBounds.min}, ${width}px, ${$897ab7f8a2e9a596$var$widthResizeBounds.max})`;
    const dangerouslyHoistSlotSizes = (0, $gwFzn.useContext)((0, $8jREP.DangerouslyHoistSlotSizes));
    const navRef = (0, $gwFzn.useRef)(null); /**
                                                       * Used to share the side nav element with the `Panel`,
                                                       * which observes the side nav to determine its maximum width.
                                                       */ 
    const sharedRef = (0, $dh62b.useSideNavRef)();
    const mergedRef = (0, $3654r.default)([
        navRef,
        sharedRef
    ]);
    const toggleButtonElement = (0, $gwFzn.useContext)((0, $5fMbj.SideNavToggleButtonElement));
    const topNavStartElement = (0, $gwFzn.useContext)((0, $7plVH.TopNavStartElement));
    const devTimeOnlyAttributes = {};
    const openLayerObserver = (0, $6UUmP.useOpenLayerObserver)();
    const flyoutStateRef = (0, $gwFzn.useRef)({
        type: 'not-active'
    });
    const isFlyoutVisible = sideNavState?.flyout === 'open';
    const updateFlyoutState = (0, $gwFzn.useMemo)(()=>{
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        }
        function open() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'open'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout !== 'open') return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: 'open'
                };
                return currentState;
            });
        }
        function close() {
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'not-active'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout === 'open') return {
                    desktop: currentState.desktop,
                    mobile: currentState.mobile,
                    flyout: 'triggered-animate-close'
                };
                return currentState;
            });
        }
        return function onAction(action) {
            if (action === 'drag-from-flyout-started') {
                open();
                flyoutStateRef.current = {
                    type: 'is-dragging-from-flyout'
                };
                return;
            }
            if (action === 'drag-from-flyout-finished') {
                open();
                return;
            } // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === 'is-dragging-from-flyout') return;
            if (action === 'open') {
                open();
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                 // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, (0, $5IbFD.sideNavFlyoutCloseDelayMs));
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                // If there are no open layers, we can close the flyout.
                if (openLayerObserver.getCount({
                    namespace: $897ab7f8a2e9a596$var$openLayerObserverSideNavNamespace
                }) === 0) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                return;
            }
            if (action === 'force-close') {
                close();
                return;
            }
        };
    }, [
        openLayerObserver,
        setSideNavState
    ]);
    const toggleVisibility = (0, $622t3.useToggleSideNav)();
    (0, $gwFzn.useEffect)(()=>{
        // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        setSideNavState({
            desktop: initialDefaultCollapsed ? 'collapsed' : 'expanded',
            mobile: 'collapsed',
            flyout: 'closed'
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState
    ]);
    const handleExpand = (0, $gwFzn.useCallback)(({ screen: screen })=>{
        onExpand?.({
            screen: screen
        }); // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState('force-close');
    }, [
        onExpand,
        updateFlyoutState
    ]);
    const handleCollapse = (0, $gwFzn.useCallback)(({ screen: screen })=>{
        onCollapse?.({
            screen: screen
        }); // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState('force-close');
    }, [
        onCollapse,
        updateFlyoutState
    ]);
    (0, $8qoQE.useSideNavVisibilityCallbacks)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile
    });
    (0, $gwFzn.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $d8F95.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibility();
                }
            }
        });
    }, [
        toggleVisibility,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]); /**
                                                                    * Close the mobile side nav if there is a click outside.
                                                                    *
                                                                    * Binding/unbinding on changes to `isExpandedOnMobile` instead of window size changes for simplicity.
                                                                    * If we listened to window size changes we'd need nested `bind()` calls.
                                                                    */ 
    (0, $gwFzn.useEffect)(()=>{
        if (!isExpandedOnMobile) return;
         /**
       * The expected URL fragment used by the side nav skip link.
       */ 
        const skipLinkUrlFragment = `#${id}`;
        return (0, $d8F95.bind)(window, {
            type: 'click',
            listener (event) {
                if (window.matchMedia('(min-width: 64rem)').matches) // Clicks on desktop should do nothing
                return;
                const sideNav = navRef.current;
                if (!sideNav || !(event.target instanceof Node)) // Ignore if our element references are invalid
                return;
                if (sideNav.contains(event.target)) // Clicks inside the side nav should not close it
                return;
                if (toggleButtonElement?.contains(event.target)) // Clicks on the toggle button will already toggle the side nav,
                // so we need to ignore it or we end up doing a double toggle
                return;
                if (event.target instanceof HTMLAnchorElement && /**
         * Intentionally using `.getAttribute()` for simplicity to match exactly what we expect
         * for skip links.
         *
         * Alternatives considered:
         *
         * - Using `.href` returns a full URL, which would then require extra parsing.
         * - Using `.hash` could incorrectly capture `<a href="/another-page#skip-link-id>` so we'd need extra checks.
         *
         * This approach has an edge case of `<a href="/same-page#skip-link-id>` not being captured,
         * but we are okay with that trade-off.
         */ event.target.getAttribute('href') === skipLinkUrlFragment) // This was a click on a link to the side nav, so we shouldn't try to collapse the SideNav.
                // It was most likely the skip link, although anyone can render a link with the ID.
                // In either case keeping the SideNav expanded makes sense.
                return;
                toggleVisibility();
            }
        });
    }, [
        id,
        isExpandedOnMobile,
        toggleButtonElement,
        toggleVisibility
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $d8F95.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                 // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) updateFlyoutState('open');
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $d8F95.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $d8F95.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                 // The user mouses has moused back over the side nav
                updateFlyoutState('open');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $d8F95.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
         // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $4T4vf.monitorForElements)({
            canMonitor ({ source: source }) {
                return nav.contains(source.element);
            },
            onGenerateDragPreview () {
                updateFlyoutState('drag-from-flyout-started');
            },
            onDrop ({ location: location }) {
                // Always marking the drag and done
                updateFlyoutState('drag-from-flyout-finished'); // If the user dropped outside of the flyout, we will close the flyout
                const underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!topNavStartElement || !toggleButtonElement) return;
        return (0, $d8F95.bind)(topNavStartElement, {
            type: 'mouseover',
            listener (event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event.target === topNavStartElement) {
                    // The mouse is directly over the TopNavStart element, so cancel any pending flyout closes.
                    updateFlyoutState('open');
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                 // The user has moused over a child element of the TopNavStart element that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!topNavStartElement) return;
        return (0, $d8F95.bind)(topNavStartElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                 // The mouse has left the TopNavStart element, so we should close the flyout with a delay.
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, TopNavStart element)
        return openLayerObserver.onChange(({ count: count })=>{
            if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) updateFlyoutState('force-close');
        }, {
            namespace: $897ab7f8a2e9a596$var$openLayerObserverSideNavNamespace
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        };
    }, []);
    (0, $38bxn.useResizingWidthCssVarOnRootElement)({
        isEnabled: (0, $dh538.fg)('platform_design_system_nav4_preview_panel_support'),
        cssVar: $897ab7f8a2e9a596$var$panelSplitterResizingVar,
        panelId: (0, $K0HEo.sideNavPanelSplitterId)
    });
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("nav", {
        id: id,
        ...devTimeOnlyAttributes,
        "data-layout-slot": true,
        "aria-label": label,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
            [(0, $K0HEo.sideNavVar)]: clampedWidth
        },
        ref: (0, $dh538.fg)('platform_design_system_nav4_preview_panel_support') ? mergedRef : navRef,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            $897ab7f8a2e9a596$var$styles.root,
            (0, $dh538.fg)('platform_design_system_nav4_sidenav_border') ? $897ab7f8a2e9a596$var$styles.newBorder : $897ab7f8a2e9a596$var$styles.oldBorder,
            isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $897ab7f8a2e9a596$var$styles.hiddenMobileOnly,
            !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $897ab7f8a2e9a596$var$styles.hiddenDesktopOnly,
            !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $897ab7f8a2e9a596$var$styles.hiddenMobileAndDesktop,
            sideNavState?.flyout === 'open' && $897ab7f8a2e9a596$var$styles.flyoutOpen,
            sideNavState?.flyout === 'open' && (0, $dh538.fg)('platform_design_system_nav4_sidenav_border') && $897ab7f8a2e9a596$var$styles.newBorderFlyoutOpen,
            sideNavState?.flyout === 'triggered-animate-close' && $897ab7f8a2e9a596$var$styles.flyoutAnimateClosed
        ]),
        children: [
            (0, $dh538.fg)('platform_design_system_nav4_preview_panel_support') && // This CSS var is used by the `Panel` slot to enforce its maximum width constraint.
            // When we remove the UNSAFE legacy usage, we can change this to `HoistCssVarToLocalGrid`
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dGAIk.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $K0HEo.sideNavLiveWidthVar),
                value: "0px",
                mediaQuery: (0, $bWLcG.media).above.md,
                responsiveValue: isExpandedOnDesktop ? `var(${$897ab7f8a2e9a596$var$panelSplitterResizingVar}, ${clampedWidth})` : 0
            }),
            dangerouslyHoistSlotSizes && ((0, $dh538.fg)('platform_design_system_nav4_preview_panel_support') ? // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dGAIk.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $K0HEo.UNSAFE_sideNavLayoutVar),
                value: `var(${(0, $K0HEo.sideNavLiveWidthVar)})`
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dGAIk.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $K0HEo.UNSAFE_sideNavLayoutVar),
                value: "0px",
                mediaQuery: (0, $bWLcG.media).above.md,
                responsiveValue: isExpandedOnDesktop ? clampedWidth : 0
            }) // ------ END UNSAFE STYLES ------
            ),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $c9vFp.PanelSplitterProvider), {
                panelId: (0, $K0HEo.sideNavPanelSplitterId),
                panelRef: navRef,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: $897ab7f8a2e9a596$var$getResizeBounds,
                resizingCssVar: $897ab7f8a2e9a596$var$panelSplitterResizingVar,
                isEnabled: isExpandedOnDesktop && !isFlyoutVisible,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                    className: (0, $35pXk.default)([
                        $897ab7f8a2e9a596$var$styles.flexContainer
                    ]),
                    children: children
                })
            })
        ]
    });
}
function $897ab7f8a2e9a596$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label, skipLinkLabel: // Default value is defined in `SideNavInternal`
skipLinkLabel = label, onExpand: // Default value is defined in `SideNavInternal`
onExpand, onCollapse: onCollapse, id: id }) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fQcKS.OpenLayerObserverNamespaceProvider), {
        namespace: $897ab7f8a2e9a596$var$openLayerObserverSideNavNamespace,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($897ab7f8a2e9a596$var$SideNavInternal, {
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            testId: testId,
            label: label,
            skipLinkLabel: skipLinkLabel,
            onExpand: onExpand,
            onCollapse: onCollapse,
            id: id,
            children: children
        })
    });
}

});
parcelRegister("fQcKS", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceProvider", () => $b83059ddc27aa2a1$export$327d0d2a7ae6f7cc);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $5Uzw3 = parcelRequire("5Uzw3");

var $cGkQr = parcelRequire("cGkQr");

var $4pUFZ = parcelRequire("4pUFZ");
function $b83059ddc27aa2a1$export$327d0d2a7ae6f7cc({ children: children, namespace: namespace }) {
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    const parentContext = (0, $4pUFZ.useOpenLayerObserverNamespace)();
    (0, $gwFzn.useEffect)(()=>{
        (0, $5Uzw3.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $cGkQr.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace,
        children: children
    });
}

});

parcelRegister("5IbFD", function(module, exports) {

$parcel$export(module.exports, "sideNavFlyoutCloseDelayMs", () => $b9b280e8233788f4$export$a7801e29f563faad);
// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $b9b280e8233788f4$export$a7801e29f563faad = 400;

});

parcelRegister("7R2w7", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibility", () => $f8794fde192899a4$export$4a602ad7e09bdb2c);

var $gwFzn = parcelRequire("gwFzn");

var $cvtof = parcelRequire("cvtof");
const $f8794fde192899a4$export$4a602ad7e09bdb2c = ({ defaultCollapsed: defaultCollapsed = false } = {})=>{
    const sideNavState = (0, $gwFzn.useContext)((0, $cvtof.SideNavVisibilityState));
    // If the context value is `null`, it means we are still in SSR, and should use the default values.
    // For desktop, it comes from the `defaultCollapsed` prop, and for mobile, it is always `false`.
    if (sideNavState === null) return {
        isExpandedOnDesktop: !defaultCollapsed,
        isExpandedOnMobile: false
    };
    return {
        isExpandedOnDesktop: sideNavState.desktop === 'expanded',
        isExpandedOnMobile: sideNavState.mobile === 'expanded'
    };
};

});

parcelRegister("8qoQE", function(module, exports) {

$parcel$export(module.exports, "useSideNavVisibilityCallbacks", () => $f521bee41562bd5b$export$1904b8f2577aba9a);

var $gwFzn = parcelRequire("gwFzn");

var $bzNqF = parcelRequire("bzNqF");
function $f521bee41562bd5b$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile }) {
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    const onExpandRef = (0, $gwFzn.useRef)(onExpand);
    const onCollapseRef = (0, $gwFzn.useRef)(onCollapse);
    (0, $gwFzn.useEffect)(()=>{
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    const previousIsExpandedOnDesktop = (0, $bzNqF.default)(isExpandedOnDesktop);
    (0, $gwFzn.useEffect)(()=>{
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnDesktop) onExpandRef.current?.({
            screen: 'desktop'
        });
        else onCollapseRef.current?.({
            screen: 'desktop'
        });
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop
    ]);
    const previousIsExpandedOnMobile = (0, $bzNqF.default)(isExpandedOnMobile);
    (0, $gwFzn.useEffect)(()=>{
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnMobile) onExpandRef.current?.({
            screen: 'mobile'
        });
        else onCollapseRef.current?.({
            screen: 'mobile'
        });
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile
    ]);
}

});

parcelRegister("622t3", function(module, exports) {

$parcel$export(module.exports, "useToggleSideNav", () => $24bc66d44c50665e$export$477ee35601a0a8ce);

var $gwFzn = parcelRequire("gwFzn");

var $5Uzw3 = parcelRequire("5Uzw3");

var $cvtof = parcelRequire("cvtof");
function $24bc66d44c50665e$export$477ee35601a0a8ce() {
    const setSideNavState = (0, $gwFzn.useContext)((0, $cvtof.SetSideNavVisibilityState));
    const toggleSideNav = (0, $gwFzn.useCallback)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        if (matches) setSideNavState((currentState)=>{
            (0, $5Uzw3.default)(currentState, 'Side nav state should not be null');
            return {
                mobile: currentState.mobile,
                desktop: currentState.desktop === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed'
            };
        });
        else setSideNavState((currentState)=>{
            (0, $5Uzw3.default)(currentState, 'Side nav state should not be null');
            return {
                desktop: currentState.desktop,
                mobile: currentState.mobile === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed'
            };
        });
    }, [
        setSideNavState
    ]);
    return toggleSideNav;
}

});


parcelRegister("3Fgla", function(module, exports) {

$parcel$export(module.exports, "GlobalInviteWithLazyLoadedRelayProvider", () => $824f685f95a3a006$export$73b6b212789f5472);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $aPgM3 = parcelRequire("aPgM3");

var $keVvA = parcelRequire("keVvA");

var $dh538 = parcelRequire("dh538");

var $7lxQk = parcelRequire("7lxQk");

var $141Kq = parcelRequire("141Kq");

var $d2vda = parcelRequire("d2vda");

var $f3So1 = parcelRequire("f3So1");

var $2UdT0 = parcelRequire("2UdT0");

const $824f685f95a3a006$var$LazyGlobalInviteModalDialogContentWithRelayProvider = /*#__PURE__*/ (0, $gwFzn.lazy)(()=>(parcelRequire("9M1xS")).then((module)=>({
            default: module.ModalDialogContentWithRelayProvider
        })));
function $824f685f95a3a006$var$AsyncGlobalInviteModalDialogContentWithRelayProvider(props) {
    const modalContent = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aPgM3.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d2vda.ErrorState), {}),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Suspense), {
            fallback: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $f3So1.LoadingState), {}),
            children: /*#__PURE__*/ (0, $7UHDa.jsx)($824f685f95a3a006$var$LazyGlobalInviteModalDialogContentWithRelayProvider, {
                ...props
            })
        })
    });
    return (0, $dh538.fg)('global_invite_uses_intl_provider') ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $keVvA.default), {
        defaultMessages: (0, $141Kq.default),
        loaderFn: (0, $7lxQk.fetchMessages),
        children: modalContent
    }) : modalContent;
}
const $824f685f95a3a006$export$73b6b212789f5472 = (0, $2UdT0.withModalDialog)($824f685f95a3a006$var$AsyncGlobalInviteModalDialogContentWithRelayProvider);

});
parcelRegister("7lxQk", function(module, exports) {

$parcel$export(module.exports, "fetchMessages", () => $86f4c496838d0464$export$e4882a930a0d91f2);

var $141Kq = parcelRequire("141Kq");

var $fzzWl = parcelRequire("fzzWl");
const $86f4c496838d0464$export$e4882a930a0d91f2 = async (locale)=>{
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $fzzWl.asyncLanguages) ? locale : locale.replace(/-/g, '_') in (0, $fzzWl.asyncLanguages) ? locale.replace(/-/g, '_') : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $fzzWl.asyncLanguages)[languageLocale]?.();
        return localeMessages?.default ?? (0, $141Kq.default);
    } catch (e) {
    // ignore
    }
    return 0, $141Kq.default;
};

});
parcelRegister("141Kq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $62841e239617d5e4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $62841e239617d5e4$export$2e2bcd8739ae039 = {
    'navigation.global-invite.error-state-description': 'Try refreshing the page or contact us if the problem persists.',
    'navigation.global-invite.error-state-heading': "We can't load the invite list right now",
    'navigation.global-invite.loading-visually-hidden-label': 'Loading',
    'navigation.global-invite.modal-dialog-label': 'Invite people'
};

});

parcelRegister("fzzWl", function(module, exports) {

$parcel$export(module.exports, "asyncLanguages", () => $9f7a555e7f9dfa42$export$3770c7a7737d463c);
// https://parceljs.org/features/dependency-resolution/#glob-specifiers

























const $9f7a555e7f9dfa42$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("epsti")),
    da: ()=>(parcelRequire("RBq2n")),
    de: ()=>(parcelRequire("kzico")),
    'en-GB': ()=>(parcelRequire("5XXKh")),
    'en-ZZ': ()=>(parcelRequire("5LB4i")),
    en: ()=>Promise.resolve((parcelRequire("141Kq"))),
    es: ()=>(parcelRequire("l902s")),
    fi: ()=>(parcelRequire("5Av2X")),
    fr: ()=>(parcelRequire("ef5nb")),
    hu: ()=>(parcelRequire("39Ypg")),
    it: ()=>(parcelRequire("8BVOR")),
    ja: ()=>(parcelRequire("8E3DF")),
    ko: ()=>(parcelRequire("4cHXW")),
    nb: ()=>(parcelRequire("aqxJp")),
    nl: ()=>(parcelRequire("gDQAp")),
    pl: ()=>(parcelRequire("eNexY")),
    'pt-BR': ()=>(parcelRequire("kiOgR")),
    ru: ()=>(parcelRequire("1YH4R")),
    sv: ()=>(parcelRequire("gG7UU")),
    th: ()=>(parcelRequire("e8w0i")),
    tr: ()=>(parcelRequire("f2459")),
    uk: ()=>(parcelRequire("6oLOH")),
    vi: ()=>(parcelRequire("fcUan")),
    zh_TW: ()=>(parcelRequire("e6iDm")),
    zh: ()=>(parcelRequire("k2Ex4"))
};

});
parcelRegister("epsti", function(module, exports) {

let $a7d97c5097d361b0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a7d97c5097d361b0$var$load("5iVCs").then(()=>parcelRequire('5xx4Y'));

});

parcelRegister("RBq2n", function(module, exports) {

let $0a11f9fa1851e133$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0a11f9fa1851e133$var$load("k7RZQ").then(()=>parcelRequire('hAVgU'));

});

parcelRegister("kzico", function(module, exports) {

let $ef95317393fb1f1e$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ef95317393fb1f1e$var$load("9CFJc").then(()=>parcelRequire('lk8G1'));

});

parcelRegister("5XXKh", function(module, exports) {

let $4580ceaa7f33a7e1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4580ceaa7f33a7e1$var$load("3fPuK").then(()=>parcelRequire('aR1vS'));

});

parcelRegister("5LB4i", function(module, exports) {

let $432e1889f098c85b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $432e1889f098c85b$var$load("dUyEb").then(()=>parcelRequire('cryKi'));

});

parcelRegister("l902s", function(module, exports) {

let $f64a77ec6566774a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f64a77ec6566774a$var$load("PAD2J").then(()=>parcelRequire('6UEa7'));

});

parcelRegister("5Av2X", function(module, exports) {

let $411865bfeed968e9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $411865bfeed968e9$var$load("GNuQo").then(()=>parcelRequire('eMR6r'));

});

parcelRegister("ef5nb", function(module, exports) {

let $a5e6a2544734bc27$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a5e6a2544734bc27$var$load("fvsAU").then(()=>parcelRequire('lqRs8'));

});

parcelRegister("39Ypg", function(module, exports) {

let $24d111d901bdc438$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $24d111d901bdc438$var$load("h7dGJ").then(()=>parcelRequire('abQPO'));

});

parcelRegister("8BVOR", function(module, exports) {

let $644ea125777e60cc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $644ea125777e60cc$var$load("kg6sH").then(()=>parcelRequire('koNv9'));

});

parcelRegister("8E3DF", function(module, exports) {

let $64b4e1b97e030ce3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $64b4e1b97e030ce3$var$load("fqF5W").then(()=>parcelRequire('lHGQG'));

});

parcelRegister("4cHXW", function(module, exports) {

let $30fa631a28c5da1f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $30fa631a28c5da1f$var$load("1WNp5").then(()=>parcelRequire('hfuHa'));

});

parcelRegister("aqxJp", function(module, exports) {

let $79767f770a211a83$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $79767f770a211a83$var$load("iHPxa").then(()=>parcelRequire('4M9Uw'));

});

parcelRegister("gDQAp", function(module, exports) {

let $c1d914634135e7dc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c1d914634135e7dc$var$load("Qf3VH").then(()=>parcelRequire('8jbH9'));

});

parcelRegister("eNexY", function(module, exports) {

let $ac50ed021bebfa34$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ac50ed021bebfa34$var$load("79OEV").then(()=>parcelRequire('4zJCj'));

});

parcelRegister("kiOgR", function(module, exports) {

let $ec7c7bd55f3f8732$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ec7c7bd55f3f8732$var$load("27dMt").then(()=>parcelRequire('h0wiX'));

});

parcelRegister("1YH4R", function(module, exports) {

let $170ccf52fc5d58e3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $170ccf52fc5d58e3$var$load("bkVVv").then(()=>parcelRequire('fARzr'));

});

parcelRegister("gG7UU", function(module, exports) {

let $c246b5b0a5bd43b3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $c246b5b0a5bd43b3$var$load("MLhYA").then(()=>parcelRequire('7wkkR'));

});

parcelRegister("e8w0i", function(module, exports) {

let $a4aaa35a40d15587$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a4aaa35a40d15587$var$load("ap7kW").then(()=>parcelRequire('7Ud5x'));

});

parcelRegister("f2459", function(module, exports) {

let $af1a35888a2d65ae$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $af1a35888a2d65ae$var$load("45YAR").then(()=>parcelRequire('dyiwH'));

});

parcelRegister("6oLOH", function(module, exports) {

let $4a8a1364e5e16ee8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4a8a1364e5e16ee8$var$load("kqhVG").then(()=>parcelRequire('i54xW'));

});

parcelRegister("fcUan", function(module, exports) {

let $b1238b7fcedc6167$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $b1238b7fcedc6167$var$load("1susf").then(()=>parcelRequire('6kAMA'));

});

parcelRegister("e6iDm", function(module, exports) {

let $a44014826d6fd4e8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a44014826d6fd4e8$var$load("dl3k2").then(()=>parcelRequire('cIqRB'));

});

parcelRegister("k2Ex4", function(module, exports) {

let $e9736f6f637519f3$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e9736f6f637519f3$var$load("aquXY").then(()=>parcelRequire('ffYaF'));

});



parcelRegister("d2vda", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $89f8b391742ea365$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $7hXDW = parcelRequire("7hXDW");

var $1GzhS = parcelRequire("1GzhS");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $dkLyX = parcelRequire("dkLyX");
const $89f8b391742ea365$var$styles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.1000',
    paddingInline: 'space.100',
    textAlign: 'center'
});
function $89f8b391742ea365$export$c1ed4f415b9e7023() {
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
        space: "space.050",
        testId: "global-invite--error-state",
        xcss: $89f8b391742ea365$var$styles,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
                size: "xsmall",
                children: formatMessage((0, $dkLyX.messages).errorStateHeading)
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5dK2X.default), {
                size: "small",
                color: "color.text.subtle",
                children: formatMessage((0, $dkLyX.messages).errorStateDescription)
            })
        ]
    });
}

});
parcelRegister("dkLyX", function(module, exports) {

$parcel$export(module.exports, "messages", () => $45a6eb3a76009dad$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $45a6eb3a76009dad$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    errorStateHeading: {
        id: "navigation.global-invite.error-state-heading",
        defaultMessage: "We can't load the invite list right now"
    },
    errorStateDescription: {
        id: "navigation.global-invite.error-state-description",
        defaultMessage: "Try refreshing the page or contact us if the problem persists."
    }
});

});


parcelRegister("f3So1", function(module, exports) {

$parcel$export(module.exports, "LoadingState", () => $1823c8a7ae00001a$export$62aa48085237e36f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $kpYGL = parcelRequire("kpYGL");

var $6F6hl = parcelRequire("6F6hl");

var $jtIsq = parcelRequire("jtIsq");
const $1823c8a7ae00001a$var$styles = (0, $ecnYn.xcss)({
    paddingBlock: 'space.500',
    paddingInline: 'space.300'
});
function $1823c8a7ae00001a$export$62aa48085237e36f() {
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const items = Array.from({
        length: 5
    }, (_, index)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $kpYGL.default), {
            isShimmering: true,
            width: "100%",
            height: "var(--ds-space-200, 16px)",
            testId: "skeleton-shimmering"
        }, index));
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $6f0Oj.default), {
        xcss: $1823c8a7ae00001a$var$styles,
        testId: "global-invite--loading-state",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6F6hl.default), {
                children: formatMessage((0, $jtIsq.messages).loadingLabel)
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1GzhS.default), {
                space: "space.100",
                testId: "skeleton-group",
                children: items
            })
        ]
    });
}

});
parcelRegister("jtIsq", function(module, exports) {

$parcel$export(module.exports, "messages", () => $527f6b7f46807211$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $527f6b7f46807211$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    loadingLabel: {
        id: "navigation.global-invite.loading-visually-hidden-label",
        defaultMessage: "Loading"
    }
});

});


parcelRegister("2UdT0", function(module, exports) {

$parcel$export(module.exports, "withModalDialog", () => $b2599bb59f3b7568$export$2d7d84d397d9a585);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $7TH2w = parcelRequire("7TH2w");

var $inPa6 = parcelRequire("inPa6");

var $ccHMk = parcelRequire("ccHMk");

var $ekolh = parcelRequire("ekolh");
var $1DHa6 = parcelRequire("1DHa6");
var $6xdDU = parcelRequire("6xdDU");

var $dh538 = parcelRequire("dh538");

var $hqHXQ = parcelRequire("hqHXQ");

var $8m1UD = parcelRequire("8m1UD");

var $7VhND = parcelRequire("7VhND");
function $b2599bb59f3b7568$export$2d7d84d397d9a585(Content) {
    return function ModalDialog({ testId: testId = (0, $hqHXQ.DEFAULT_TEST_ID), triggerElement: TriggerElement, children: children, ...props }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, $dBxQj.default)();
        const [isModalDialogOpen, setIsModalDialogOpen] = (0, $gwFzn.useState)(false);
        const [adminHasNavigatedAway, setAdminHasNavigatedAway] = (0, $gwFzn.useState)(false);
        const openModalDialog = (0, $gwFzn.useCallback)(()=>{
            if ((0, $dh538.fg)('platform_global-invite-analytics')) createAnalyticsEvent({
                eventType: (0, $7TH2w.UI_EVENT_TYPE),
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'globalInviteButton',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $hqHXQ.ANALYTICS_CHANNEL));
            setIsModalDialogOpen(true);
        }, [
            createAnalyticsEvent,
            props.product
        ]);
        const onAdminMenuItemClick = (0, $gwFzn.useCallback)((event)=>{
            // See packages/people-and-teams/invite-people/src/components/DropdownMenu/AdminMenuGroup.tsx for where these items are created.
            // Handle the click event happening on a link directly, or on an inner <span> or similar
            const isLink = event?.target?.tagName === 'A';
            const link = isLink ? event?.target : event?.target?.closest('a');
            if (link && (link?.getAttribute('target') === 'new' || link?.getAttribute('target') === '_blank')) setAdminHasNavigatedAway(true);
        }, []);
        const onCancel = (0, $gwFzn.useCallback)(()=>{
            if ((0, $dh538.fg)('platform_global-invite-analytics')) createAnalyticsEvent({
                eventType: (0, $7TH2w.UI_EVENT_TYPE),
                action: adminHasNavigatedAway ? 'closed' : 'cancelled',
                actionSubject: 'modalDialog',
                actionSubjectId: 'globalInviteModal',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $hqHXQ.ANALYTICS_CHANNEL));
            setIsModalDialogOpen(false);
        }, [
            createAnalyticsEvent,
            props.product,
            adminHasNavigatedAway
        ]);
        const onInviteCompleted = (0, $gwFzn.useCallback)(()=>{
            createAnalyticsEvent({
                eventType: (0, $7TH2w.UI_EVENT_TYPE),
                action: 'completed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'globalInviteModal',
                attributes: {
                    componentName: 'globalInvite',
                    product: props.product
                }
            }).fire((0, $hqHXQ.ANALYTICS_CHANNEL));
            setIsModalDialogOpen(false);
        }, [
            createAnalyticsEvent,
            props.product
        ]);
        const focusDialog = (0, $gwFzn.useCallback)((node)=>{
            // Focus the dialog's container when it finishes opening
            node.focus();
        }, []);
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8m1UD.AnalyticsContextWrapper), {
            product: props.product,
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                "data-testid": testId,
                children: [
                    TriggerElement ? /*#__PURE__*/ (0, $7UHDa.jsx)(TriggerElement, {
                        onClick: openModalDialog
                    }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                        shouldFitContainer: true,
                        onClick: openModalDialog,
                        testId: `${testId}--${(0, $hqHXQ.TRIGGER_ELEMENT_TEST_ID)}`,
                        children: children
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6xdDU.default), {
                        children: isModalDialogOpen ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ekolh.default), {
                            width: "small",
                            shouldScrollInViewport: true,
                            shouldReturnFocus: true,
                            onClose: onCancel,
                            onOpenComplete: focusDialog,
                            label: formatMessage((0, $7VhND.messages).modalDialogLabel),
                            testId: `${testId}--${(0, $hqHXQ.MODAL_DIALOG_TEST_ID)}`,
                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1DHa6.default), {
                                children: (0, $dh538.fg)('platform_global-invite-analytics-admin-nav') ? /*#__PURE__*/ (0, $7UHDa.jsx)(Content, {
                                    onAdminMenuItemClick: onAdminMenuItemClick,
                                    onCancel: onCancel,
                                    onInviteCompleted: onInviteCompleted,
                                    ...props
                                }) : /*#__PURE__*/ (0, $7UHDa.jsx)(Content, {
                                    onCancel: onCancel,
                                    onInviteCompleted: onInviteCompleted,
                                    ...props
                                })
                            })
                        }) : null
                    })
                ]
            })
        });
    };
}

});
parcelRegister("hqHXQ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_TEST_ID", () => $52241f5d84d6a74c$export$bb76aeb9f599715c);
$parcel$export(module.exports, "MODAL_DIALOG_TEST_ID", () => $52241f5d84d6a74c$export$7622d28bacf170d1);
$parcel$export(module.exports, "TRIGGER_ELEMENT_TEST_ID", () => $52241f5d84d6a74c$export$1dab7caa4b20a4cc);
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $52241f5d84d6a74c$export$85183a312807388d);
const $52241f5d84d6a74c$export$bb76aeb9f599715c = 'global-invite';
const $52241f5d84d6a74c$export$7622d28bacf170d1 = 'modal-dialog';
const $52241f5d84d6a74c$export$1dab7caa4b20a4cc = 'trigger-element';
const $52241f5d84d6a74c$export$85183a312807388d = 'navigation';

});

parcelRegister("8m1UD", function(module, exports) {

$parcel$export(module.exports, "AnalyticsContextWrapper", () => $c1f1e75d1b3ddd53$export$804bcbe0913c6ba3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $ffCOo = parcelRequire("ffCOo");

var $dh538 = parcelRequire("dh538");
function $c1f1e75d1b3ddd53$export$804bcbe0913c6ba3({ product: product, children: children }) {
    if ((0, $dh538.fg)('platform_global-invite-analytics')) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ffCOo.NavigationAnalyticsContext), {
        data: {
            componentName: 'globalInvite',
            source: 'globalInviteButton',
            product: product
        },
        children: children
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
        children: children
    });
}

});

parcelRegister("7VhND", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1fe379e53d021c39$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $1fe379e53d021c39$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    modalDialogLabel: {
        id: "navigation.global-invite.modal-dialog-label",
        defaultMessage: "Invite people"
    }
});

});


parcelRegister("9M1xS", function(module, exports) {

let $71d9cba03429ac16$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $71d9cba03429ac16$var$load("9gJO7"),
    $71d9cba03429ac16$var$load("hKqxh"),
    $71d9cba03429ac16$var$load("7sseo"),
    $71d9cba03429ac16$var$load("45SdR"),
    $71d9cba03429ac16$var$load("dFNh6"),
    $71d9cba03429ac16$var$load("joJy8"),
    $71d9cba03429ac16$var$load("aHE9G"),
    $71d9cba03429ac16$var$load("9n4ur"),
    $71d9cba03429ac16$var$load("1ruJB"),
    $71d9cba03429ac16$var$load("hYWtF"),
    $71d9cba03429ac16$var$load("5JvKa"),
    $71d9cba03429ac16$var$load("1TOYq"),
    $71d9cba03429ac16$var$load("h3VCR"),
    $71d9cba03429ac16$var$load("kGIBm"),
    $71d9cba03429ac16$var$load("69J1q"),
    $71d9cba03429ac16$var$load("ffEVr"),
    $71d9cba03429ac16$var$load("gY1B8")
]).then(()=>parcelRequire('gFKFJ'));

});


parcelRegister("iQuWQ", function(module, exports) {

$parcel$export(module.exports, "CoordinatedNav4OnboardingModal", () => $c4b9458df42c5a82$export$c8e90da6b6eeea31);

var $gwFzn = parcelRequire("gwFzn");

var $axAnW = parcelRequire("axAnW");

var $jmjWc = parcelRequire("jmjWc");

var $lwNi3 = parcelRequire("lwNi3");

var $9wGTI = parcelRequire("9wGTI");

var $bQm3c = parcelRequire("bQm3c");

var $dIouf = parcelRequire("dIouf");

var $5gBuB = parcelRequire("5gBuB");

const $c4b9458df42c5a82$var$Nav4OnboardingModalLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "KxGQc",
    name: "Nav4OnboardingModalLoader",
    loader: async ()=>(await (parcelRequire("WDWbc"))).Nav4OnboardingModal
});
const $c4b9458df42c5a82$var$ONBOARDING_MODAL_MESSAGE_ID = 'cc-nav-4-onboarding-prod';
const $c4b9458df42c5a82$export$c8e90da6b6eeea31 = ()=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const coordinationClient = (0, $lwNi3.useCoordinationClient)(false);
    const { hasDismissedNav4Modal: hasDismissedNav4Modal, loading: loading, error: error } = (0, $5gBuB.useHasDismissedNav4Modal)();
    const [showModal, setShowModal] = (0, $gwFzn.useState)(true);
    const onClose = ()=>{
        setShowModal(false);
        coordinationClient.stop($c4b9458df42c5a82$var$ONBOARDING_MODAL_MESSAGE_ID);
        userId && (0, $5gBuB.setHasDismissedNav4Modal)(userId);
    };
    if (!showModal || hasDismissedNav4Modal || loading || !(0, $9wGTI.fg)('confluence_nav_4_changeboarding')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $axAnW.default), {
        client: coordinationClient,
        messageId: $c4b9458df42c5a82$var$ONBOARDING_MODAL_MESSAGE_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c4b9458df42c5a82$var$Nav4OnboardingModalLoader, {
        onClose: onClose
    })), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }));
};

});
parcelRegister("WDWbc", function(module, exports) {

let $0b0465a0589f3bc8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0b0465a0589f3bc8$var$load("gNtBf").then(()=>parcelRequire('jtCJa'));

});


parcelRegister("dzFiN", function(module, exports) {

$parcel$export(module.exports, "useIsEligibleForEnhanceOrientationTour", () => $639e37d83b439e79$export$603899985a6b6d0d);

var $5PE1K = parcelRequire("5PE1K");

var $8dwdz = parcelRequire("8dwdz");

var $ivb8S = parcelRequire("ivb8S");

var $dCb9P = parcelRequire("dCb9P");

var $gz8ZY = parcelRequire("gz8ZY");

var $9wGTI = parcelRequire("9wGTI");

var $dojsn = parcelRequire("dojsn");
const $639e37d83b439e79$export$603899985a6b6d0d = ()=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    // Onboarding state to check when they've seen the tour
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        ...Object.values((0, $dojsn.ENHANCE_ORIENTATION_TOUR_ONBOARDING_STATE_KEYS))
    ]);
    const isDesktopUser = !((0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)());
    const { tourSeenAt: tourSeenAt, hasDismissedTour: hasDismissedTour, hasSeenFinishNudge: hasSeenFinishNudge, hasCompletedTour: hasCompletedTour } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const isInOnboardingPeriod = Boolean(tourSeenAt) && (0, $5PE1K.default)(new Date(), new Date(tourSeenAt)) <= 7;
    const tourExpired = Boolean(tourSeenAt) && (0, $5PE1K.default)(new Date(), new Date(tourSeenAt)) > 7;
    const potentiallyEligibleUserForTour = !tourExpired && isDesktopUser && isNav4Enabled;
    const { isLandUser: isLandUser, isXflowUser: isXflowUser, error: userTypeError, loading: userTypeLoading } = (0, $dCb9P.useUserByLicensedProducts)({
        skip: !potentiallyEligibleUserForTour || !(0, $9wGTI.fg)('cc-onboarding-enhance-orientation-tour-eligible')
    });
    if (userTypeLoading || onboardingStateLoading) return {
        isEligibleForLand: false,
        isEligibleForXflow: false,
        loading: true,
        error: false,
        hasDismissedTour: hasDismissedTour,
        hasSeenFinishNudge: hasSeenFinishNudge,
        hasCompletedTour: hasCompletedTour,
        isXflowUser: isXflowUser
    };
    if (userTypeError || onboardingStateError) return {
        isEligibleForLand: false,
        isEligibleForXflow: false,
        loading: false,
        error: userTypeError || onboardingStateError,
        hasDismissedTour: hasDismissedTour,
        hasSeenFinishNudge: hasSeenFinishNudge,
        hasCompletedTour: hasCompletedTour,
        isXflowUser: isXflowUser
    };
    return {
        isEligibleForLand: isLandUser && (tourSeenAt === undefined || isInOnboardingPeriod),
        isEligibleForXflow: isXflowUser && (tourSeenAt === undefined || isInOnboardingPeriod),
        loading: false,
        error: false,
        hasDismissedTour: hasDismissedTour,
        hasCompletedTour: hasCompletedTour,
        hasSeenFinishNudge: hasSeenFinishNudge,
        tourSeenAt: tourSeenAt,
        isXflowUser: isXflowUser
    };
};

});

parcelRegister("dFqEJ", function(module, exports) {

$parcel$export(module.exports, "EnhanceOrientationTourNudgeLoader", () => $cd81a3b55a785b10$export$26025b42ccef1069);

var $jmjWc = parcelRequire("jmjWc");

const $cd81a3b55a785b10$export$26025b42ccef1069 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "eT3I0",
    name: "EnhanceOrientationTourNudgeLoader",
    loader: async ()=>(await (parcelRequire("aryhf"))).EnhanceOrientationTourNudge
});

});
parcelRegister("aryhf", function(module, exports) {

let $79a703bf19d06adc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $79a703bf19d06adc$var$load("jDLw3").then(()=>parcelRequire('3RUZF'));

});


parcelRegister("8w7kh", function(module, exports) {

$parcel$export(module.exports, "RtPaidFeatureEducationComponentLoadable", () => $5698f55a07ee58a9$export$cfb35a627665c154);

var $jmjWc = parcelRequire("jmjWc");

const $5698f55a07ee58a9$export$cfb35a627665c154 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "AAnbP",
    name: "RtPaidFeatureEducationComponentLoadable",
    loader: async ()=>(await (parcelRequire("60ySs"))).RtPaidFeatureEducationComponent
});

});
parcelRegister("60ySs", function(module, exports) {

let $45fdcc1188050569$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $45fdcc1188050569$var$load("7sZmN"),
    $45fdcc1188050569$var$load("bgLDW"),
    $45fdcc1188050569$var$load("h7GGc"),
    $45fdcc1188050569$var$load("i0oSV")
]).then(()=>parcelRequire('fulxh'));

});


parcelRegister("73ZeC", function(module, exports) {

$parcel$export(module.exports, "NavigationBannerLoadable", () => $f78d5c0572b89011$export$527a85921fd1998c);

var $jmjWc = parcelRequire("jmjWc");

const $f78d5c0572b89011$export$527a85921fd1998c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "lvxzi",
    name: "NavigationBannerLoadable",
    loader: async ()=>(await (parcelRequire("2l6Py"))).AdminUpsellNavigationBanner
});

});
parcelRegister("2l6Py", function(module, exports) {

let $1b42d7599af4e61a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1b42d7599af4e61a$var$load("7sZmN"),
    $1b42d7599af4e61a$var$load("iyhyY"),
    $1b42d7599af4e61a$var$load("eufZR"),
    $1b42d7599af4e61a$var$load("ffEVr"),
    $1b42d7599af4e61a$var$load("4vd0S")
]).then(()=>parcelRequire('7FipJ'));

});


parcelRegister("ib3XP", function(module, exports) {

$parcel$export(module.exports, "Nav4CollapseReminderSpotlightLoader", () => $f542602a6e0f4176$export$4283c4ef2b834aa2);
$parcel$export(module.exports, "useHasDismissedNav4CollapseReminderSpotlight", () => (parcelRequire("92JEG")).useHasDismissedNav4CollapseReminderSpotlight);

var $jmjWc = parcelRequire("jmjWc");

var $92JEG = parcelRequire("92JEG");

const $f542602a6e0f4176$export$4283c4ef2b834aa2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "USWMG",
    name: "Nav4CollapseReminderSpotlightLoader",
    loader: async ()=>(await (parcelRequire("jN7d6"))).Nav4CollapseReminderSpotlight
});

});
parcelRegister("92JEG", function(module, exports) {

$parcel$export(module.exports, "useHasDismissedNav4CollapseReminderSpotlight", () => $d66becf3e4056778$export$8bcdb86a7ad5ef4b);

var $ivb8S = parcelRequire("ivb8S");

var $dBcar = parcelRequire("dBcar");
const $d66becf3e4056778$export$8bcdb86a7ad5ef4b = ()=>{
    const { data: data } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED)
    ]);
    const { isNav4CollapseReminderSpotlightDismissed: isNav4CollapseReminderSpotlightDismissed } = (0, $ivb8S.deserializeState)(data);
    return {
        isNav4CollapseReminderSpotlightDismissed: isNav4CollapseReminderSpotlightDismissed
    };
};

});

parcelRegister("jN7d6", function(module, exports) {

let $e6882fc0a8adb7fb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $e6882fc0a8adb7fb$var$load("fSc0b").then(()=>parcelRequire('vavBY'));

});


parcelRegister("5UY0r", function(module, exports) {

$parcel$export(module.exports, "SideNavigationContent", () => $b524a1c7212bd91f$export$fc95973351613945);

var $gwFzn = parcelRequire("gwFzn");

var $cFYM0 = parcelRequire("cFYM0");

var $eGUIL = parcelRequire("eGUIL");
const $b524a1c7212bd91f$export$fc95973351613945 = ({ children: children })=>{
    const sideNavRef = (0, $gwFzn.useRef)(null);
    const handleScrollToTop = (0, $gwFzn.useCallback)(()=>{
        if (sideNavRef.current) sideNavRef.current.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [
        sideNavRef
    ]);
    const contextValue = (0, $gwFzn.useMemo)(()=>({
            sideNavRef: sideNavRef,
            handleScrollToTop: handleScrollToTop
        }), [
        sideNavRef,
        handleScrollToTop
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eGUIL.SideNavigationContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cFYM0.SideNavContent), {
        ref: sideNavRef
    }, children));
};

});
parcelRegister("cFYM0", function(module, exports) {

$parcel$export(module.exports, "SideNavContent", () => $9c1f04fccaeb1d16$export$babe3c784778f3ba);
/* side-nav-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $9c1f04fccaeb1d16$export$babe3c784778f3ba = /*#__PURE__*/ (0, $gwFzn.forwardRef)($9c1f04fccaeb1d16$var$_SideNavContent); // Placing this const below the function breaks Compiled!
const $9c1f04fccaeb1d16$var$styles = {
    scrollContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo1wug _18m91wug",
    paddingContainer: "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
function $9c1f04fccaeb1d16$var$_SideNavContent({ children: children, testId: testId }, ref) {
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            $9c1f04fccaeb1d16$var$styles.scrollContainer
        ]),
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            className: (0, $35pXk.default)([
                $9c1f04fccaeb1d16$var$styles.paddingContainer
            ]),
            children: children
        })
    });
}

});


parcelRegister("fKEgu", function(module, exports) {

$parcel$export(module.exports, "useSideNavInitialState", () => $1b5aa9dc12e56400$export$6deddaa54d32585b);

var $6zNhq = parcelRequire("6zNhq");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");
const $1b5aa9dc12e56400$var$DEFAULT_SIDEBAR_WIDTH = 320;
const $1b5aa9dc12e56400$export$6deddaa54d32585b = ()=>{
    const { isPanelOpen: isPanelOpen, isDismissed: isDismissed } = (0, $6zNhq.useQuickstartState)();
    const shouldForceExpand = isPanelOpen && !isDismissed;
    const persistedCollapseState = (0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED) ?? 'expanded';
    const persistedWidth = parseInt((0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_WIDTH) || $1b5aa9dc12e56400$var$DEFAULT_SIDEBAR_WIDTH, 10);
    const initialCollapsedState = shouldForceExpand ? 'expanded' : persistedCollapseState;
    const fittedSidebarWidth = persistedWidth > window.innerWidth ? $1b5aa9dc12e56400$var$DEFAULT_SIDEBAR_WIDTH : persistedWidth;
    return {
        initialCollapsedState: initialCollapsedState,
        initialWidth: fittedSidebarWidth,
        shouldForceExpand: shouldForceExpand
    };
};

});

parcelRegister("c5xYC", function(module, exports) {

$parcel$export(module.exports, "Nav4GiveFeedbackButton", () => $2f95c06461436630$export$6a0cee38b7084887);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $6fjxX = parcelRequire("6fjxX");

var $3gadb = parcelRequire("3gadb");

var $iI2ST = parcelRequire("iI2ST");

var $b27jz = parcelRequire("b27jz");
const $2f95c06461436630$export$6a0cee38b7084887 = ({ iconOnly: iconOnly = false })=>{
    const intl = (0, $dBxQj.default)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $b27jz.useNav4FeedbackCollectorActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: intl.formatMessage($2f95c06461436630$var$i18n.shareFeedbackButtonText)
    }, iconOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6fjxX))),
        onClick: openFeedbackCollector,
        label: intl.formatMessage($2f95c06461436630$var$i18n.shareFeedbackButtonText)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-vc": "nav4-give-feedback-sidebar-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iI2ST.ButtonMenuItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6fjxX))), {
            label: "",
            color: "currentColor",
            testId: "nav4-give-feedback-sidebar-button-icon-temp-do-not-use"
        }),
        onClick: openFeedbackCollector
    }, intl.formatMessage($2f95c06461436630$var$i18n.shareFeedbackButtonText))));
};
const $2f95c06461436630$var$i18n = (0, $2nPZH.defineMessages)({
    shareFeedbackButtonText: {
        id: "page-layout.nav4.feedback-collector.share-feedback-button.text",
        defaultMessage: "Give feedback on the new navigation"
    }
});

});

parcelRegister("cLmDJ", function(module, exports) {

$parcel$export(module.exports, "useSideNavigationCollapsedActions", () => $6be64d70b45c3bb0$export$ee6f665bc19ef05d);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $6be64d70b45c3bb0$var$initialState = {
    isCollapsed: false
};
const $6be64d70b45c3bb0$var$actions = {
    setIsCollapsed: (collapsed)=>({ setState: setState })=>{
            setState({
                isCollapsed: collapsed
            });
        }
};
const $6be64d70b45c3bb0$export$c0c3c6fb1b0fe561 = (0, $4ZoIm.createStore)({
    initialState: $6be64d70b45c3bb0$var$initialState,
    actions: $6be64d70b45c3bb0$var$actions
});
const $6be64d70b45c3bb0$export$7d924aef7db527f0 = (0, $iFWZA.createHook)($6be64d70b45c3bb0$export$c0c3c6fb1b0fe561);
const $6be64d70b45c3bb0$export$ee6f665bc19ef05d = (0, $iFWZA.createActionsHook)($6be64d70b45c3bb0$export$c0c3c6fb1b0fe561);

});


parcelRegister("JEZ6P", function(module, exports) {

$parcel$export(module.exports, "TopNav", () => $f06013f8e99ab858$export$41d0d88a6b0e456f);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $hnvzE = parcelRequire("hnvzE");

var $hsPNq = parcelRequire("hsPNq");

var $eaL9e = parcelRequire("eaL9e");

var $cH8F2 = parcelRequire("cH8F2");

var $dIouf = parcelRequire("dIouf");

var $hayzU = parcelRequire("hayzU");

var $7NOdL = parcelRequire("7NOdL");
const $f06013f8e99ab858$export$41d0d88a6b0e456f = ({ defaultCollapsed: defaultCollapsed })=>{
    const { data: data, error: error } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $7NOdL.ThemeQuery));
    const horizontalHeader = data?.lookAndFeel?.custom?.horizontalHeader;
    const customTheme = (0, $cH8F2.useCustomTheme)(horizontalHeader?.backgroundColor, horizontalHeader?.primaryNavigation?.highlightColor);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hsPNq.TopNav), {
        testId: "grid-topNav",
        UNSAFE_theme: customTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hnvzE.default), {
        name: "top-nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eaL9e.TopNavigationBase), {
        defaultCollapsed: defaultCollapsed
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hayzU.LazyImpersonationFlag), null)), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }));
};

});
parcelRegister("eaL9e", function(module, exports) {

$parcel$export(module.exports, "TopNavigationBase", () => $d782f4c4ad49c391$export$eff75454f2208b30);

var $gwFzn = parcelRequire("gwFzn");

var $7d2Nc = parcelRequire("7d2Nc");

var $8w1c1 = parcelRequire("8w1c1");

var $dIouf = parcelRequire("dIouf");

var $fkfv7 = parcelRequire("fkfv7");
const $d782f4c4ad49c391$export$eff75454f2208b30 = ({ defaultCollapsed: defaultCollapsed })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).DISCO,
        attributes: {
            errorBoundaryId: 'TopNavigation'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: (0, $8w1c1.APP_NAVIGATION_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fkfv7.TopNavigation), {
        defaultCollapsed: defaultCollapsed
    }));
};

});
parcelRegister("fkfv7", function(module, exports) {

$parcel$export(module.exports, "TopNavigation", () => $d7fa51f310118f21$export$8a421bddecb2bf5b);

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $5izcQ = parcelRequire("5izcQ");

var $e1eDr = parcelRequire("e1eDr");

var $9S2JE = parcelRequire("9S2JE");

var $dTIqH = parcelRequire("dTIqH");
var $idPUB = parcelRequire("idPUB");
var $9vGun = parcelRequire("9vGun");

var $bQm3c = parcelRequire("bQm3c");

var $dIouf = parcelRequire("dIouf");

var $irVI7 = parcelRequire("irVI7");
var $1eaCJ = parcelRequire("1eaCJ");
var $1kHsc = parcelRequire("1kHsc");

var $b8XTE = parcelRequire("b8XTE");

var $8w1c1 = parcelRequire("8w1c1");

var $kVysQ = parcelRequire("kVysQ");
var $4NX9d = parcelRequire("4NX9d");

var $de2j9 = parcelRequire("de2j9");

var $ljm2R = parcelRequire("ljm2R");

var $XLQOT = parcelRequire("XLQOT");

var $9wGTI = parcelRequire("9wGTI");

var $c5zvz = parcelRequire("c5zvz");

var $bwL2u = parcelRequire("bwL2u");

var $7Sm4c = parcelRequire("7Sm4c");

var $3RlfX = parcelRequire("3RlfX");

var $eBBZq = parcelRequire("eBBZq");

var $1B659 = parcelRequire("1B659");

var $kOJbK = parcelRequire("kOJbK");

var $CoPbv = parcelRequire("CoPbv");

var $9MAeh = parcelRequire("9MAeh");

var $cHJoe = parcelRequire("cHJoe");

var $6hFFA = parcelRequire("6hFFA");

var $3yPEN = parcelRequire("3yPEN");

var $kBOGD = parcelRequire("kBOGD");

var $eDVeb = parcelRequire("eDVeb");

var $cAMBp = parcelRequire("cAMBp");
const $d7fa51f310118f21$export$8a421bddecb2bf5b = ({ defaultCollapsed: defaultCollapsed })=>{
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $3RlfX.TopNavigationQuery), {
        variables: {
            includeNav4AdminOptIn: (0, $9wGTI.fg)('confluence_nav4_ga_phase_1')
        }
    });
    if ((0, $dIouf.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    if (loading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($d7fa51f310118f21$var$TopNavigationInner, {
        data: data,
        defaultCollapsed: defaultCollapsed
    }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }));
};
const $d7fa51f310118f21$var$isAtlassianStaff = (data)=>{
    return data?.user?.emails?.some((email)=>email?.value && (email.value.endsWith('@atlassian.com') || email.value.endsWith('@atlassian.com.invalid') || email.value.endsWith('@usersinbuckets.com'))) || false;
};
const $d7fa51f310118f21$var$TopNavigationInner = ({ data: data, defaultCollapsed: defaultCollapsed })=>{
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isAtlassianStaffMemoized = (0, $gwFzn.useMemo)(()=>$d7fa51f310118f21$var$isAtlassianStaff(data), [
        data
    ]);
    const getShortcutVisualizer = (0, $gwFzn.useCallback)((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
            contentBefore: label,
            shortcut: (0, $ljm2R.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
            isEditorShortcut: isOnEditRoute,
            isTooltip: true
        }), [
        isOnEditRoute
    ]);
    const [{ isMultiSelectActive: isMultiSelectActive }, { exitMultiSelect: exitMultiSelect }] = (0, $bwL2u.useContentTreeSelection)();
    const handleMultiSelectOnCollapse = (0, $gwFzn.useCallback)(()=>{
        if (isMultiSelectActive) {
            exitMultiSelect();
            experienceTracker.abort({
                name: (0, $irVI7.BULK_ACTIONS_IN_CONTENT_TREE_EXPERIENCE),
                reason: 'collapsed side nav'
            });
        }
    }, [
        isMultiSelectActive,
        exitMultiSelect,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9vGun.TopNavStart), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
        name: "nav4-spotlight-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9S2JE.SideNavToggleButton), {
        defaultCollapsed: defaultCollapsed,
        collapseLabel: getShortcutVisualizer(formatMessage($d7fa51f310118f21$var$i18n.sideNavToggleButtonCollapseLabel)),
        expandLabel: getShortcutVisualizer(formatMessage($d7fa51f310118f21$var$i18n.sideNavToggleButtonExpandLabel)),
        onClick: handleMultiSelectOnCollapse
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eBBZq.AppSwitcherButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1B659.DeveloperButtons), {
        isAtlassianStaff: isAtlassianStaffMemoized
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kOJbK.SiteLogoButton), {
        siteConfiguration: data?.siteConfiguration,
        siteSettings: data?.siteSettings,
        siteDescription: data?.siteDescription
    }), data?.siteSettings?.showApplicationTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $e1eDr.CustomTitle), null, data?.siteSettings.siteTitle) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $idPUB.TopNavMiddle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eDVeb.SearchBar), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kBOGD.CreateComponent), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dTIqH.TopNavEnd), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $XLQOT.EditionAwareness), null), (0, $9wGTI.fg)('edition_awareness_standard_upsell_confluence_ab_fg') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c5zvz.EditionAwarenessUpsellExperiment), {
        navVersion: "nav4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cAMBp.RovoButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9MAeh.NotificationsButton), {
        user: data?.user
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $CoPbv.HelpButton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cHJoe.SettingsButton), null), isLoggedIn && data?.user ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
        name: "nav-profile"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6hFFA.AccountButton), {
        user: data.user
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3yPEN.LoginButton), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.APP_NAV_GLOBAL_EXPERIENCE),
        attributes: {
            navVersion: '4'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
        metric: (0, $8w1c1.APP_NAVIGATION_METRIC),
        customData: {
            isAnonymous: !isLoggedIn
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4NX9d.PerformanceEnd), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigation),
        subjectId: "NavigationLoading",
        includeFeatureFlags: true,
        details: $d7fa51f310118f21$var$nav4Details
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4NX9d.PerformanceEnd), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigationFMP),
        subjectId: "NavigationFMP",
        includeFeatureFlags: true,
        details: $d7fa51f310118f21$var$nav4Details
    }));
};
const $d7fa51f310118f21$var$i18n = (0, $2nPZH.defineMessages)({
    sideNavToggleButtonCollapseLabel: {
        id: "app-navigation.top-navigation.side-nav-toggle-button-collapse-label",
        defaultMessage: "Collapse sidebar"
    },
    sideNavToggleButtonExpandLabel: {
        id: "app-navigation.top-navigation.side-nav-toggle-button-expand-label",
        defaultMessage: "Expand sidebar"
    }
});
const $d7fa51f310118f21$var$nav4Details = {
    navVersion: '4'
};

});
parcelRegister("9S2JE", function(module, exports) {

$parcel$export(module.exports, "SideNavToggleButton", () => $31c01975bf558c1d$export$8bd77667631fec25);
/* toggle-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $3uA7H = parcelRequire("3uA7H");

var $cN7t9 = parcelRequire("cN7t9");

var $dh538 = parcelRequire("dh538");

var $aaBfd = parcelRequire("aaBfd");

var $5fMbj = parcelRequire("5fMbj");

var $7R2w7 = parcelRequire("7R2w7");

var $622t3 = parcelRequire("622t3");
const $31c01975bf558c1d$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
}; // For duplicate "mouseenter" issue when changing icons (see below)
const $31c01975bf558c1d$var$silentIconStyles = null; /**
                                * __SideNavToggleButton__
                                *
                                * Button for toggling the side nav. It should be used in the top bar.
                                */ 
const $31c01975bf558c1d$export$8bd77667631fec25 = ({ defaultCollapsed: defaultCollapsed = false, expandLabel: expandLabel, collapseLabel: collapseLabel, testId: testId, interactionName: interactionName, onClick: onClick })=>{
    const { isExpandedOnDesktop: isSideNavExpandedOnDesktop, isExpandedOnMobile: isSideNavExpandedOnMobile } = (0, $7R2w7.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    const [isSideNavExpanded, setIsSideNavExpanded] = (0, $gwFzn.useState)(!defaultCollapsed);
    const ref = (0, $gwFzn.useContext)((0, $5fMbj.SideNavToggleButtonAttachRef));
    const elementRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $dh538.fg)('platform_fix_component_state_update_for_suspense')) ref(elementRef.current);
    }, [
        elementRef,
        ref
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        setIsSideNavExpanded(matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // When screen size changes, ensure we use the correct visibility state
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $d8F95.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                setIsSideNavExpanded(mediaQueryList.matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
            }
        });
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    const toggleVisibility = (0, $622t3.useToggleSideNav)();
    const handleClick = (0, $gwFzn.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent, {
            isSideNavVisible: isSideNavExpanded
        });
        toggleVisibility();
    }, [
        onClick,
        toggleVisibility,
        isSideNavExpanded
    ]); /**
                                                       * ## Behaviour
                                                       * It is intentional that collapse icon will be used while the flyout is open.
                                                       * The icon is tied to the expanded / collapse state, and not the flyout state.
                                                       *
                                                       * ## Why a function?
                                                       * Unfortunately, changing the icon inside an <IconButton> when the user is over
                                                       * the button will cause the svg element to be replaced, which can trigger a
                                                       * "mouseenter" event. This is problematic when the user is already over the button,
                                                       * as it can result in a "mouseenter" event after the user manually entered the button.
                                                       *
                                                       * `icon` accepts a function for the `icon` prop (ie a render prop), so we don't need to
                                                       * memoize it, or pull it out into a new function
                                                       */ 
    const icon = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)("span", {
            className: (0, $35pXk.default)([
                "_1e0c1bgi _lcxvglyw"
            ]),
            children: isSideNavExpanded ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3uA7H))), {
                ...props,
                testId: testId ? `${testId}-collapse-icon-temp-do-not-use` : undefined
            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cN7t9))), {
                ...props,
                testId: testId ? `${testId}-expand-icon-temp-do-not-use` : undefined
            })
        });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $aaBfd.IconButton), {
        appearance: "subtle",
        label: isSideNavExpanded ? collapseLabel : expandLabel,
        icon: icon,
        onClick: handleClick,
        testId: testId,
        isTooltipDisabled: false,
        interactionName: interactionName,
        ref: (0, $dh538.fg)('platform_fix_component_state_update_for_suspense') ? elementRef : ref,
        tooltip: $31c01975bf558c1d$var$toggleButtonTooltipOptions
    });
};

});
parcelRegister("3uA7H", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::abc8b5d03c24733db4f330a1621745d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28b031be5ae5f446$var$_react = $28b031be5ae5f446$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $28b031be5ae5f446$var$_baseNew = $28b031be5ae5f446$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $28b031be5ae5f446$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $28b031be5ae5f446$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $28b031be5ae5f446$var$_react.default.createElement($28b031be5ae5f446$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$28b031be5ae5f446$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $28b031be5ae5f446$var$_default = module.exports.default = $28b031be5ae5f446$var$SidebarCollapseIcon;

});

parcelRegister("cN7t9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5f4e0f9a7acbecae432a6a2607234087>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94ffdadf1a3ed504$var$_react = $94ffdadf1a3ed504$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $94ffdadf1a3ed504$var$_baseNew = $94ffdadf1a3ed504$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $94ffdadf1a3ed504$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $94ffdadf1a3ed504$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $94ffdadf1a3ed504$var$_react.default.createElement($94ffdadf1a3ed504$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-2v-11zm-3.5 0v11H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.03 7.47l-2.5-2.5-1.06 1.06L6.44 8 4.47 9.97l1.06 1.06 2.5-2.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$94ffdadf1a3ed504$var$SidebarExpandIcon.displayName = 'SidebarExpandIcon';
var $94ffdadf1a3ed504$var$_default = module.exports.default = $94ffdadf1a3ed504$var$SidebarExpandIcon;

});


parcelRegister("kOJbK", function(module, exports) {

$parcel$export(module.exports, "SiteLogoButton", () => $760ef9e13b699b30$export$48df75a983e1f3fb);
/* SiteLogoButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $guzTv = parcelRequire("guzTv");
var $cs19m = parcelRequire("cs19m");

var $aj8rL = parcelRequire("aj8rL");

var $dPJCf = parcelRequire("dPJCf");

var $epLE5 = parcelRequire("epLE5");

var $1NBp8 = parcelRequire("1NBp8");

var $gz8ZY = parcelRequire("gz8ZY");

const $760ef9e13b699b30$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("80zTh"))).fireLogoClickedAnalytics);
const $760ef9e13b699b30$var$customLogo = null;
const $760ef9e13b699b30$var$ConfluenceIconComponent = ()=>// tokens were not used because @atlaskit/temp-nav-app-icons/confluence icon/logo
    // have their own padding and 5px was the only way to make the icons align.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        style: {
            marginTop: '5px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $guzTv.ConfluenceIcon), {
        size: "24"
    }));
const $760ef9e13b699b30$export$48df75a983e1f3fb = ({ siteConfiguration: siteConfiguration, siteSettings: siteSettings, siteDescription: siteDescription })=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onClick = $760ef9e13b699b30$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef.current?.routeName);
    const siteTitle = siteSettings && siteSettings.siteTitle;
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const CustomNavLogo = (0, $gwFzn.useMemo)(()=>{
        if (siteConfiguration?.customSiteLogo && siteDescription?.logoUrl) {
            if (isNav4Enabled) return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("img", {
                    alt: "",
                    src: siteDescription.logoUrl
                });
            return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("img", {
                    alt: "",
                    src: siteDescription.logoUrl,
                    className: (0, $35pXk.default)([
                        "_1bsb1f4h _4t3i1f4h"
                    ])
                });
        }
        return null;
    }, [
        isNav4Enabled,
        siteConfiguration?.customSiteLogo,
        siteDescription?.logoUrl
    ]);
    const logo = CustomNavLogo || (0, $cs19m.ConfluenceLogo);
    const icon = CustomNavLogo || $760ef9e13b699b30$var$ConfluenceIconComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aj8rL.NavLogo), {
        label: siteTitle ?? 'Confluence',
        logo: logo,
        icon: icon,
        onClick: onClick,
        href: (0, $1NBp8.WIKI).toUrl()
    });
};

});
parcelRegister("80zTh", function(module, exports) {

let $5d4a29f10a315bcd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5d4a29f10a315bcd$var$load("2b5QF").then(()=>parcelRequire('1FDBc'));

});


parcelRegister("CoPbv", function(module, exports) {

$parcel$export(module.exports, "HelpButton", () => $48d2632049a03f8d$export$78bddedbcf2939ac);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $6xdDU = parcelRequire("6xdDU");

var $hOWPZ = parcelRequire("hOWPZ");

var $jln20 = parcelRequire("jln20");

var $bBQPT = parcelRequire("bBQPT");

var $dEBDF = parcelRequire("dEBDF");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $dPJCf = parcelRequire("dPJCf");

var $ljm2R = parcelRequire("ljm2R");

var $bQIml = parcelRequire("bQIml");

var $7yPTi = parcelRequire("7yPTi");

var $jmjWc = parcelRequire("jmjWc");

var $efvKr = parcelRequire("efvKr");

var $de2j9 = parcelRequire("de2j9");

const $48d2632049a03f8d$var$HelpMenuLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "xFVld",
    name: "HelpMenuLoader",
    loader: async ()=>(await (parcelRequire("9wRSS"))).HelpMenu
});
const $48d2632049a03f8d$export$78bddedbcf2939ac = ()=>{
    const triggerButtonRef = (0, $gwFzn.useRef)(null);
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const inProductHelp = (0, $bBQPT.useInProductHelpActions)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const routeData = (0, $dPJCf.useRouteDataRef)();
    const intl = (0, $dBxQj.default)();
    const isHelpPanelOpen = rightSidebarContext.getCurrent()?.panelId === (0, $bBQPT.HELP_PANEL_ID);
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const [activeDialog, setActiveDialog] = (0, $gwFzn.useState)(null);
    const onClick = ()=>{
        if (isHelpPanelOpen) rightSidebarContext.close((0, $bBQPT.HELP_PANEL_ID));
        else {
            experienceTracker.start({
                name: (0, $irVI7.VIEW_IN_PRODUCT_HELP_EXPERIENCE),
                attributes: {
                    navVersion: '4'
                }
            });
            rightSidebarContext.open((0, $bBQPT.HELP_PANEL_ID), (0, $bBQPT.HELP_PANEL_WIDTH));
            rightSidebarContext.setTriggerButtonRef?.(triggerButtonRef);
            const { routeName: routeName, routeGroup: routeGroup } = (0, $bBQPT.getRouteData)(routeData.current?.href || '');
            inProductHelp.setRouteName(routeName);
            inProductHelp.setRouteGroup(routeGroup);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'help',
                attributes: {
                    selectedItemPageContext: routeData.current?.routeName,
                    navigationLayer: 'global',
                    navigationContainer: 'top',
                    navVersion: '4',
                    navdexPointType: (0, $dEBDF.START_TOUCH)
                }
            }
        }).fire();
    };
    const closeDialog = (0, $gwFzn.useCallback)(()=>{
        setActiveDialog(null);
    }, [
        setActiveDialog
    ]);
    const openDialog = (0, $gwFzn.useCallback)((dialog)=>{
        setActiveDialog(dialog(closeDialog));
    }, [
        setActiveDialog,
        closeDialog
    ]);
    const openShortcutsDialog = ()=>openDialog((onClose)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bQIml.KeyboardShortcutsDialog), {
                onClose: onClose
            }));
    const preloadMenu = ()=>{
        (0, $7yPTi.preloadHelpMenu)();
        $48d2632049a03f8d$var$HelpMenuLoader.preload();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        onMouseEnter: preloadMenu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hOWPZ.Help), {
        onClick: onClick,
        label: intl.formatMessage($48d2632049a03f8d$var$i18n.help),
        isSelected: isHelpPanelOpen,
        ref: triggerButtonRef
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        accelerator: isLiveEditMode || isOnEditRoute ? (0, $ljm2R.UNIVERSAL_HELP_SHORTCUT) : [
            (0, $ljm2R.HELP_SHORTCUT),
            (0, $ljm2R.UNIVERSAL_HELP_SHORTCUT)
        ],
        listener: openShortcutsDialog,
        isAppNavigationShortcut: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6xdDU.default), null, activeDialog));
};
const $48d2632049a03f8d$var$i18n = (0, $2nPZH.defineMessages)({
    help: {
        id: "app-navigation.top-navigation.help",
        defaultMessage: "Help"
    }
});

});
parcelRegister("9wRSS", function(module, exports) {

let $6f00e67b75971447$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6f00e67b75971447$var$load("9n4ur"),
    $6f00e67b75971447$var$load("1ruJB"),
    $6f00e67b75971447$var$load("1ISAt"),
    $6f00e67b75971447$var$load("mKoWX"),
    $6f00e67b75971447$var$load("lfEn7"),
    $6f00e67b75971447$var$load("4PQXU"),
    $6f00e67b75971447$var$load("89mul"),
    $6f00e67b75971447$var$load("6vzdH"),
    $6f00e67b75971447$var$load("1epse"),
    $6f00e67b75971447$var$load("5joXW"),
    $6f00e67b75971447$var$load("c6MKV"),
    $6f00e67b75971447$var$load("ffEVr"),
    $6f00e67b75971447$var$load("joJy8"),
    $6f00e67b75971447$var$load("aHE9G"),
    $6f00e67b75971447$var$load("6H998")
]).then(()=>parcelRequire('bbp2J'));

});


parcelRegister("cHJoe", function(module, exports) {

$parcel$export(module.exports, "SettingsButton", () => $5f8faa2e47e4a6d0$export$e2457e1974c298c3);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $inPa6 = parcelRequire("inPa6");

var $9xVAL = parcelRequire("9xVAL");

var $dEBDF = parcelRequire("dEBDF");

var $dPJCf = parcelRequire("dPJCf");

var $d9tcB = parcelRequire("d9tcB");
var $bQm3c = parcelRequire("bQm3c");

var $1NBp8 = parcelRequire("1NBp8");
const $5f8faa2e47e4a6d0$export$e2457e1974c298c3 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const routeData = (0, $dPJCf.useRouteDataRef)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const onClick = (e)=>{
        const url = (0, $1NBp8.ADMIN_SETTINGS).toUrl();
        if (e.metaKey) window.open(url, '_blank', 'noreferrer');
        else push(url);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'settings',
                attributes: {
                    selectedItemPageContext: routeData.current?.routeName,
                    navigationLayer: 'global',
                    navVersion: '4',
                    navdexPointType: (0, $dEBDF.START_TOUCH)
                }
            }
        }).fire();
    };
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    return isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9xVAL.Settings), {
        onClick: onClick,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $5f8faa2e47e4a6d0$var$i18n.settings)
    }) : null;
};
const $5f8faa2e47e4a6d0$var$i18n = (0, $2nPZH.defineMessages)({
    settings: {
        id: "app-navigation.top-navigation.settings",
        defaultMessage: "Confluence administration"
    }
});

});

parcelRegister("6hFFA", function(module, exports) {

$parcel$export(module.exports, "AccountButton", () => $e40e4f4e333d3274$export$6d6e8f8ac62271dd);

var $gwFzn = parcelRequire("gwFzn");

var $6xdDU = parcelRequire("6xdDU");

var $41c4c = parcelRequire("41c4c");

var $eD3cX = parcelRequire("eD3cX");
const $e40e4f4e333d3274$export$6d6e8f8ac62271dd = ({ user: user })=>{
    const [activeDialog, setActiveDialog] = (0, $gwFzn.useState)(null);
    const closeDialog = (0, $gwFzn.useCallback)(()=>{
        setActiveDialog(null);
    }, [
        setActiveDialog
    ]);
    const openDialog = (0, $gwFzn.useCallback)((dialog)=>{
        setActiveDialog(dialog(closeDialog));
    }, [
        setActiveDialog,
        closeDialog
    ]);
    const preloadMenu = (0, $gwFzn.useCallback)(()=>{
        (0, $41c4c.preloadProfileMenu)();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        onMouseEnter: preloadMenu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eD3cX.AccountMenu), {
        user: user,
        dialogFn: openDialog
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6xdDU.default), null, activeDialog));
};

});
parcelRegister("eD3cX", function(module, exports) {

$parcel$export(module.exports, "AccountMenu", () => $22e97f2cae5620a3$export$ff20d75d5eda4388);
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $diswb = parcelRequire("diswb");

var $dBxQj = parcelRequire("dBxQj");

var $7rvPL = parcelRequire("7rvPL");

var $cv4vy = parcelRequire("cv4vy");

var $eSLr0 = parcelRequire("eSLr0");
var $6ld6a = parcelRequire("6ld6a");

var $bQm3c = parcelRequire("bQm3c");

var $esKit = parcelRequire("esKit");

var $bbp3G = parcelRequire("bbp3G");

var $gqqjz = parcelRequire("gqqjz");

var $ku3HK = parcelRequire("ku3HK");

var $9wGTI = parcelRequire("9wGTI");

var $jEeDd = parcelRequire("jEeDd");

var $7J5Uc = parcelRequire("7J5Uc");

var $c5zvz = parcelRequire("c5zvz");

var $hOfle = parcelRequire("hOfle");

var $g4wMf = parcelRequire("g4wMf");

var $kniSK = parcelRequire("kniSK");
const $22e97f2cae5620a3$var$AccountMenuTrashedPersonalSpacesQuery = (0, $d2LG0.default)`query AccountMenuTrashedPersonalSpacesQuery($creatorAccountIds:[String!]){spaces(type:"PERSONAL" creatorAccountIds:$creatorAccountIds status:"TRASHED"){nodes{alias key id}}}`;
/* Excluded web items include 'confluence.user.menu:user-favourites' (carried over from ProfileMenu)
 * as well as web items that are already supported by the platform Account Menu.
 * We are passing in an excluded list instead of an included list to avoid missing any web items.
 * Currently expected web items include the following:
 * - com.atlassian.confluence.plugins.confluence-frontend-support:adg3-give-feedback
 * - confluence.user.menu:create-personal-space
 * - confluence.user.menu:personal-space
 * - confluence.user.menu:admin-restore-personal-space
 * - com.atlassian.confluence.plugins.confluence-inline-tasks:my-tasks-menu-item
 * - confluence.user.menu:settings
 * - com.atlassian.plugins.atlassian-connect-plugin:confluence-chats-integration__profile
 * - extension points (begin with com.atlassian.plugins.atlassian-connect-plugin:connect-playground-confluence)
 */ const $22e97f2cae5620a3$var$EXCLUDED_WEB_ITEMS = [
    'confluence.user.menu:user-favourites',
    'confluence.user.menu:user-profile',
    'confluence.user.menu:user-theme',
    'confluence.user.menu:logout'
];
const $22e97f2cae5620a3$var$getManageAccountUrl = (destinationAccountEmail, environment)=>{
    const loginLink = (0, $jEeDd.getLoginLink)($22e97f2cae5620a3$var$getAtlassianPersonalSettingsLink(environment));
    return `${loginLink}&login_hint=${encodeURIComponent(destinationAccountEmail)}&prompt=none`;
};
const $22e97f2cae5620a3$var$getSwitchAccountUrl = ()=>{
    const loginLink = (0, $jEeDd.getLoginLink)();
    return `${loginLink}&prompt=select_account`;
};
const $22e97f2cae5620a3$var$getAtlassianPersonalSettingsLink = (environment)=>{
    return environment === 'PRODUCTION' ? 'https://id.atlassian.com/manage-profile/profile-and-visibility' : 'https://id.stg.internal.atlassian.com/manage-profile/profile-and-visibility';
};
const $22e97f2cae5620a3$var$AccountMenuComponent = /*#__PURE__*/ (0, $gwFzn.memo)(({ user: user, webItems: webItems, webSections: webSections, dialogFn: dialogFn, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    const userId = user?.id || '';
    const profileIconUrl = user?.photos?.[0]?.value || '';
    const accountEmail = user?.emails?.[0]?.value || '';
    const accountDisplayName = user?.displayName || '';
    const manageAccountUrl = $22e97f2cae5620a3$var$getManageAccountUrl(accountEmail, environment);
    const switchAccountUrl = $22e97f2cae5620a3$var$getSwitchAccountUrl();
    const [themeState, themingActions] = (0, $7J5Uc.useThemingState)();
    const persistentUpgradeMenuSection = (0, $esKit.usePersistentUpgradeMenuSection)();
    const standardToPremiumEASection = (0, $c5zvz.useConfluenceStandardToPremiumPUBTouchpoint)('nav4');
    const nav4OptItem = (0, $g4wMf.useNav4OptOutMenuItem)();
    const [itemSelected, setItemSelected] = (0, $gwFzn.useState)(undefined);
    // if webItems has 'admin-restore-personal-space', then we need to call the query to get the trashed personal space data
    const hasTrashedPersonalSpace = webItems.some((obj)=>obj.completeKey === 'confluence.user.menu:admin-restore-personal-space');
    const { data: data } = (0, $diswb.useQuery)($22e97f2cae5620a3$var$AccountMenuTrashedPersonalSpacesQuery, {
        skip: !hasTrashedPersonalSpace,
        variables: {
            creatorAccountIds: [
                userId || ''
            ]
        }
    });
    const node = data?.spaces?.nodes?.[0];
    const spaceKey = node?.key || '';
    const spaceId = node?.id || '';
    const spaceAlias = node?.alias || '';
    const { handleRestoreClick: handleRestoreClick } = (0, $ku3HK.useTrashedSpace)({
        spaceKey: spaceKey,
        spaceAlias: spaceAlias,
        spaceId: spaceId,
        flags: flags,
        source: 'profileMenu'
    });
    const callbackActions = {
        'user-theme': ()=>{
            itemSelected === 'user-theme' ? setItemSelected(undefined) : setItemSelected('user-theme');
        },
        'admin-restore-personal-space': ()=>handleRestoreClick()
    };
    const menuItems = (0, $hOfle.useWebItemMapper)(webItems, webSections, {
        userId: userId,
        callbackActions: callbackActions
    });
    // only show optItem when BETA/EAP FF is on, but not part of phase 2.
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    const nav4OptItems = !(0, $9wGTI.fg)('confluence_nav4_ga_phase_2') && (0, $9wGTI.fg)('confluence_nav_4') ? [
        nav4OptItem
    ] : [];
    const accountMenuItems = [
        ...persistentUpgradeMenuSection,
        ...standardToPremiumEASection,
        ...menuItems,
        ...nav4OptItems
    ];
    const getSectionTitle = (group)=>{
        if (group.heading) {
            if (typeof group.heading === 'string') return group.heading;
            else return formatMessage(group.heading);
        } else return undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cv4vy.AccountMenuNav3), {
        testId: "confluence-account-menu",
        name: accountDisplayName,
        picture: profileIconUrl,
        trustPicture: true,
        email: accountEmail,
        viewProfileLink: "/wiki/users/viewmyprofile.action",
        manageProfileLink: manageAccountUrl,
        logOutLink: "/wiki/logout.action",
        currentTheme: themeState?.theme?.colorMode,
        onThemeChange: themingActions.setColorModePreference,
        switchAccountLink: switchAccountUrl,
        extraMenuItems: accountMenuItems.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7rvPL.default), {
                key: getSectionTitle(group),
                hasSeparator: true,
                title: getSectionTitle(group)
            }, group.items.map((item)=>{
                const itemGetDialog = item.hasOwnProperty('getDialog') ? item.getDialog : null;
                const dialogHandler = itemGetDialog ? ()=>{
                    dialogFn(itemGetDialog);
                } : null;
                const onClick = item.action || dialogHandler;
                const closeAction = item.closeAction;
                const onClickHandler = ()=>{
                    if (closeAction) closeAction();
                    if (onClick) onClick();
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kniSK.PopupMenuItemComponent), {
                    key: item.key,
                    item: item,
                    onClickHandler: onClickHandler,
                    closeMenu: closeAction || (()=>{}),
                    isSelected: itemSelected === item.key
                });
            })))
    });
});
const $22e97f2cae5620a3$export$ff20d75d5eda4388 = /*#__PURE__*/ (0, $gwFzn.memo)(({ user: user, dialogFn: dialogFn })=>{
    const { webItems: webItems, webSections: webSections } = (0, $6ld6a.useWebItemLocation)({
        location: (0, $eSLr0.SYSTEM_USER),
        notAllowedWebItems: $22e97f2cae5620a3$var$EXCLUDED_WEB_ITEMS
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $bbp3G.DialogsStateContainer),
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (dialogs, flags)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($22e97f2cae5620a3$var$AccountMenuComponent, {
            user: user,
            dialogFn: dialogFn,
            // @ts-expect-error - Type 'WebItem[]' is not assignable to type 'WebItem[]'
            webItems: webItems,
            webSections: webSections,
            dialogs: dialogs,
            flags: flags
        });
    });
});

});




parcelRegister("cH8F2", function(module, exports) {

$parcel$export(module.exports, "useCustomTheme", () => $a61833f951c42c7b$export$c0c5f5b297b77726);

var $j5cB3 = parcelRequire("j5cB3");

var $ih4dR = parcelRequire("ih4dR");
const $a61833f951c42c7b$export$c0c5f5b297b77726 = (backgroundColorRaw, highlightColorRaw)=>{
    const isDarkMode = (0, $j5cB3.useIsDarkMode)();
    return (0, $ih4dR.getCustomTheme)({
        backgroundColorRaw: backgroundColorRaw,
        highlightColorRaw: highlightColorRaw,
        isDarkMode: isDarkMode,
        isNav4Enabled: true
    });
};

});




//# sourceMappingURL=PageLayout.1b9345c2.js.map
